module.exports={render:function (){
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (this.$store.state.is_auth) ? _c('div', [(!_vm.form_ErrorMessage) ? [_c('transition', {
    key: "transitionError",
    attrs: {
      "name": "fadeControl"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.localErrorMessage !== ''),
      expression: "localErrorMessage !== ''"
    }],
    staticClass: "alert alert-danger margin-20-0",
    attrs: {
      "role": "alert"
    }
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "title": _vm._f("ftc")('main/close')
    },
    on: {
      "click": function($event) {
        _vm.localErrorMessage = ''
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc(_vm.localErrorMessage)),
      expression: "localeFtc(localErrorMessage)"
    }],
    staticStyle: {
      "padding": "0",
      "margin": "0"
    }
  })])]), _vm._v(" "), (_vm.listData && _vm.listData.title && (_vm.crud === 'ipptrpool' || _vm.crud === 'iphistory')) ? _c('h4', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.listData.title)))]) : _vm._e(), _vm._v(" "), (_vm.listConfig) ? _c('div', {
    key: "mainBlock"
  }, [_c('div', {
    staticClass: "search-and-filters"
  }, [(_vm.listConfig['fast_search'] !== false) ? _c('div', {
    staticClass: "form-inline fast-search"
  }, [_c('Field', {
    ref: "fastSearch",
    staticClass: "fast-search-input",
    class: {
      'logs': _vm.$store.state.user_type === 'admin' && _vm.crud === 'logs'
    },
    attrs: {
      "isVisibleRow": true,
      "crud": _vm.crud,
      "action": "list",
      "name": "fastSearch",
      "Field": {
        _field_name: 'fastSearch',
        type: 'text',
        title: 'main/all_fields_search',
        '_visible': true
      },
      "removeRightPadding": true,
      "clearButton": true
    },
    on: {
      "event_ClearButtonClicked": _vm.fastSearchClear,
      "fastSearchInput": _vm.fastSearchEvent
    },
    model: {
      value: (_vm.fastSearchValue),
      callback: function($$v) {
        _vm.fastSearchValue = $$v
      },
      expression: "fastSearchValue"
    }
  }), _vm._v(" "), (_vm.$store.state.user_type === 'admin' && _vm.crud === 'logs') ? _c('Field', {
    ref: "ipBlackList",
    staticClass: "ip-list-input",
    attrs: {
      "isVisibleRow": true,
      "crud": _vm.crud,
      "action": "list",
      "name": "ipBlackList",
      "Field": {
        _field_name: 'ipBlackList',
        type: 'text',
        title: 'main/ip',
        '_visible': true
      },
      "removeRightPadding": true,
      "searchButton": true
    },
    on: {
      "event_SearchButtonClicked": _vm.ipBlackListClick,
      "enterKeyDown": _vm.ipBlackListClick
    },
    model: {
      value: (_vm.ipBlackListValue),
      callback: function($$v) {
        _vm.ipBlackListValue = $$v
      },
      expression: "ipBlackListValue"
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-inline filter-links-block"
  }, [(_vm.listConfig && _vm.listConfig['filters'] && _vm.listConfig['filters']['period'] && _vm.filters['period']['visible'] !== -1) ? _c('span', {
    staticClass: "widget-link",
    class: {
      'widget-link-grayed': _vm.filters['period']['visible'] === true
    },
    on: {
      "click": function($event) {
        return _vm.toggleFilter('period')
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm._f("ftc")('filter/period')) + "\n\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.listConfig && _vm.listConfig['filters'] && _vm.listConfig['filters']['radio'] && _vm.filters.radio) ? [_vm._l((_vm.filters.radio), function(radio, idx) {
    return [(radio.visible !== -1) ? _c('span', {
      key: 'radio-filter' + idx,
      staticClass: "widget-link",
      class: {
        'widget-link-grayed': _vm.filters['radio'][idx]['visible'] === true
      },
      on: {
        "click": function($event) {
          return _vm.toggleFilter('radio', idx)
        }
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("capitalize")(_vm._f("ftc")(radio.title))) + "\n\t\t\t\t\t\t\t")]) : _vm._e()]
  })] : _vm._e(), _vm._v(" "), (_vm.listConfig && _vm.listConfig['filters'] && _vm.listConfig['filters']['select'] && _vm.filters.select) ? [_vm._l((_vm.filters.select), function(select, idx) {
    return [(select.visible !== -1) ? _c('span', {
      key: 'select-filter' + idx,
      staticClass: "widget-link",
      class: {
        'widget-link-grayed': _vm.filters['select'][idx]['visible'] === true, 'hidden': _vm.crud === 'document' && _vm.$store.state.user_type === 'admin' && !_vm.accountGlobalFilter
      },
      on: {
        "click": function($event) {
          return _vm.toggleFilter('select', idx)
        }
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("capitalize")(_vm._f("ftc")(select.title))) + "\n\t\t\t\t\t\t\t")]) : _vm._e()]
  })] : _vm._e(), _vm._v(" "), (_vm.listConfig && _vm.listConfig['filters'] && _vm.listConfig['filters']['ticketLabel'] && _vm.filters['ticketLabel']['visible'] !== -1) ? _c('span', {
    staticClass: "widget-link",
    class: {
      'widget-link-grayed': _vm.filters['ticketLabel']['visible'] === true
    },
    on: {
      "click": function($event) {
        return _vm.toggleFilter('ticketLabel')
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm._f("ftc")('ticket/label')) + "\n\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.listConfig && _vm.listConfig['filters'] && _vm.listConfig['filters']['diskType'] && _vm.filters['diskType']['visible'] !== -1) ? _c('span', {
    staticClass: "widget-link",
    class: {
      'widget-link-grayed': _vm.filters['diskType']['visible'] === true
    },
    on: {
      "click": function($event) {
        return _vm.toggleFilter('diskType')
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm._f("ftc")('main/type')) + "\n\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.listConfig && _vm.listConfig['filters'] && _vm.listConfig['filters']['myTickets'] && !_vm.isCrudFilterOnMyTicket) ? _c('span', {
    staticClass: "widget-link",
    on: {
      "click": _vm.myTicketsActivate
    }
  }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm._f("ftc")('ticket/mine_tickets')) + "\n\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.listConfig && _vm.listConfig['filters'] && _vm.listConfig['filters']['planParams'] && _vm.filters['planParams']['visible'] !== -1) ? _c('span', {
    staticClass: "widget-link",
    class: {
      'widget-link-grayed': _vm.filters['planParams']['visible'] === true
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.toggleFilter('planParams')
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm._f("ftc")('main/parameters')) + "\n\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.listConfig && _vm.listConfig['filters'] && _vm.listConfig['filters']['bool'] && _vm.filters.bool.visible !== -1) ? _c('filterBool', {
    attrs: {
      "name": "switcher",
      "titleTrue": _vm.listConfig['filters']['bool']['title_true'],
      "titleFalse": _vm.listConfig['filters']['bool']['title_false'],
      "value": _vm.filters.bool.value
    },
    on: {
      "input": _vm.filterBoolEvent
    }
  }) : _vm._e(), _vm._v(" "), (_vm.listConfig && _vm.listConfig['filters'] && _vm.listConfig['filters']['logs'] && _vm.filters['logs']['visible'] !== -1) ? _c('span', {
    staticClass: "widget-link",
    class: {
      'widget-link-grayed': _vm.filters['logs']['visible'] === true
    },
    on: {
      "click": function($event) {
        return _vm.toggleFilter('logs')
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm._f("ftc")('logs/action')) + "\n\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.crud === 'ticket' && _vm.$store.state.user_type === 'client' && _vm.isUnreadedTickets && _vm.isAccess('ticket/update')) ? _c('span', {
    staticClass: "widget-link",
    attrs: {
      "title": _vm._f("ftc")('ticket/mark_all_as_readed_title')
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.markTicketsAsReaded($event)
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm._f("ftc")('ticket/mark_all_as_readed')) + "\n\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.crud === 'operation' && _vm.$store.state.user_type === 'admin') ? _c('span', {
    staticClass: "widget-link",
    attrs: {
      "title": _vm._f("ftc")('operation/convert_title')
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.operationTripleFilter($event)
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm._f("ftc")('operation/convert_title')) + "\n\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.countActiveFilters > 1) ? _c('font-awesome-icon', {
    staticClass: "remove-all-filters",
    attrs: {
      "icon": "times-circle",
      "title": _vm._f("ftc")('main/close')
    },
    on: {
      "click": _vm.closeAllFilters
    }
  }) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "widgets-filters-wrapper"
  }, [(_vm.listConfig && _vm.listConfig['filters'] && _vm.listConfig['filters']['period'] && _vm.listData && _vm.listData['filters']) ? _c('filterPeriod', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.filters.period.visible),
      expression: "filters.period.visible"
    }],
    key: "filterPeriod",
    attrs: {
      "valueBegin": _vm.filters.period.valueBegin,
      "valueEnd": _vm.filters.period.valueEnd
    },
    on: {
      "closeFilter": function($event) {
        return _vm.toggleFilter('period')
      },
      "input": _vm.filterPeriodEvent
    }
  }) : _vm._e(), _vm._v(" "), (_vm.listConfig && _vm.listConfig['filters'] && _vm.listConfig['filters']['radio'] && _vm.filters.radio && _vm.listData && _vm.listData['filters']) ? _vm._l((_vm.filters.radio), function(radio, idx) {
    return _c('filterRadio', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.filters.radio[idx].visible),
        expression: "filters.radio[idx].visible"
      }],
      key: 'radio_filter_' + idx,
      attrs: {
        "list": _vm.listData['filters'][radio.field],
        "crud": _vm.crud,
        "name": _vm.filters.radio[idx].field
      },
      on: {
        "closeFilter": function($event) {
          return _vm.toggleFilter('radio', idx)
        },
        "input": function($event) {
          return _vm.PreRequestListDataRadioFilter(_vm.filters.radio[idx])
        }
      },
      model: {
        value: (_vm.filters.radio[idx].value),
        callback: function($$v) {
          _vm.$set(_vm.filters.radio[idx], "value", $$v)
        },
        expression: "filters.radio[idx].value"
      }
    })
  }) : _vm._e(), _vm._v(" "), (_vm.listConfig && _vm.listConfig['filters'] && _vm.listConfig['filters']['select'] && _vm.filters.select && _vm.listData && _vm.listData['filters']) ? _vm._l((_vm.filters.select), function(select, idx) {
    return _c('filterSelect', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.filters.select[idx].visible),
        expression: "filters.select[idx].visible"
      }],
      key: 'select_filter_' + idx,
      attrs: {
        "list": _vm.listData['filters'][select.field],
        "name": _vm.filters.select[idx].field,
        "startVisible": _vm.filters.select[idx].visible,
        "multiselect": _vm.filters.select[idx].multiselect,
        "crud": _vm.crud
      },
      on: {
        "closeFilter": function($event) {
          return _vm.toggleFilter('select', idx)
        },
        "input": function($event) {
          return _vm.PreRequestListDataSelectFilter(_vm.filters.select[idx])
        }
      },
      model: {
        value: (_vm.filters.select[idx].value),
        callback: function($$v) {
          _vm.$set(_vm.filters.select[idx], "value", $$v)
        },
        expression: "filters.select[idx].value"
      }
    })
  }) : _vm._e(), _vm._v(" "), (_vm.listConfig && _vm.listConfig['filters'] && _vm.listConfig['filters']['logs'] && _vm.filters.logs && _vm.listData && _vm.listData['filters']) ? _c('filterLogs', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.filters.logs.visible),
      expression: "filters.logs.visible"
    }],
    key: "filterLogs",
    attrs: {
      "list": _vm.listData['filters'][_vm.listConfig['filters']['logs']['field']]
    },
    on: {
      "closeFilter": function($event) {
        return _vm.toggleFilter('logs')
      },
      "input": _vm.filterLogsEvent
    },
    model: {
      value: (_vm.filters.logs.value),
      callback: function($$v) {
        _vm.$set(_vm.filters.logs, "value", $$v)
      },
      expression: "filters.logs.value"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.listConfig && _vm.listConfig['filters'] && _vm.listConfig['filters']['ticketLabel'] && _vm.filters.ticketLabel && _vm.listData && _vm.listData['filters'] && _vm.listData['filters']['ticket_label'] && _vm.listData['filters']['ticket_label']['list']) ? _c('filterLabel', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.filters.ticketLabel.visible),
      expression: "filters.ticketLabel.visible"
    }],
    key: "filterLabel",
    attrs: {
      "items": _vm.listData['filters']['ticket_label']['list']
    },
    on: {
      "input": _vm.filterTicketLabelEvent
    },
    model: {
      value: (_vm.filters.ticketLabel.value),
      callback: function($$v) {
        _vm.$set(_vm.filters.ticketLabel, "value", $$v)
      },
      expression: "filters.ticketLabel.value"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.listConfig && _vm.listConfig['filters'] && _vm.listConfig['filters']['diskType'] && _vm.listData && _vm.listData['filters'] && _vm.listData['filters']['service_type_id'] && _vm.listData['filters']['service_type_id']['list']) ? _c('filterDisk', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.filters.diskType.visible),
      expression: "filters.diskType.visible"
    }],
    key: "filterDisk",
    attrs: {
      "items": _vm.listData['filters']['service_type_id']['list'],
      "value": _vm.filters.diskType.value
    },
    on: {
      "closeFilter": function($event) {
        return _vm.toggleFilter('diskType')
      },
      "input": _vm.filterDiskTypeEvent
    }
  }) : _vm._e(), _vm._v(" "), (_vm.listConfig &&
    _vm.listConfig['filters'] &&
    _vm.listConfig['filters']['planParams'] &&
    _vm.filters.planParams &&
    _vm.listData &&
    _vm.listData['filters'] &&
    _vm.listData['filters']['cpu_min'] &&
    _vm.listData['filters']['cpu_max'] &&
    _vm.listData['filters']['ram_min'] &&
    _vm.listData['filters']['ram_max'] &&
    _vm.listData['filters']['disk_min'] &&
    _vm.listData['filters']['disk_max']) ? _c('filterParams', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.filters.planParams.visible),
      expression: "filters.planParams.visible"
    }],
    key: "filterParams",
    attrs: {
      "params": {
        cpu_min: _vm.listData['filters']['cpu_min'],
        cpu_max: _vm.listData['filters']['cpu_max'],
        ram_min: _vm.listData['filters']['ram_min'],
        ram_max: _vm.listData['filters']['ram_max'],
        disk_min: _vm.listData['filters']['disk_min'],
        disk_max: _vm.listData['filters']['disk_max']
      },
      "visible": _vm.filters.planParams.visible
    },
    on: {
      "closeDirectlyFilter": function($event) {
        return _vm.closeDirectlyFilter('planParams')
      },
      "input": _vm.filterParamsEvent
    },
    model: {
      value: (_vm.filters.planParams.value),
      callback: function($$v) {
        _vm.$set(_vm.filters.planParams, "value", $$v)
      },
      expression: "filters.planParams.value"
    }
  }) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "other-filters"
  }, [(_vm.crudFilter && _vm.crud === _vm.crudFilter['crud']) ? _c('div', {
    staticClass: "alert alert-info w5-crud-filter-object"
  }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm._f("ftc")('main/set_filter')) + "\n\t\t\t\t\t\t"), _c('span', {
    staticClass: "label label-primary"
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.crudFilter['text'])))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.clearCrudFilter
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('span', {
    staticClass: "clearfix"
  })]) : _vm._e(), _vm._v(" "), (_vm.accountGlobalFilter && (_vm.crud !== 'iphistory' && _vm.crud !== 'ipptrpool')) ? _c('div', {
    staticClass: "alert alert-success w5-account-global-filter"
  }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.accountGlobalFilter.title) + "\n\t\t\t\t\t\t"), _c('span', {
    staticClass: "label label-success"
  }, [_vm._v(_vm._s(_vm.accountGlobalFilter.text))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.clearAccountGlobalFilter
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('span', {
    staticClass: "clearfix"
  })]) : _vm._e(), _vm._v(" "), (_vm.crudHttpGetFilter && _vm.crud === _vm.crudHttpGetFilter['__crud']) ? _c('div', {
    staticClass: "alert alert-info w5-crud-filter-object"
  }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm._f("ftc")('main/set_filter')) + "\n\t\t\t\t\t\t"), _c('span', {
    staticClass: "label label-primary"
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.crudHttpFilterTitle)))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.clearHttpCrudFilter
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('span', {
    staticClass: "clearfix"
  })]) : _vm._e()])]), _vm._v(" "), (_vm.listConfig && _vm.listConfig['buttons'] && Object.keys(_vm.listConfig['buttons']).length > 0) ? _c('div', {
    staticClass: "w5-list-buttons-block"
  }, [_vm._l((_vm.listConfig['buttons']), function(button, btn) {
    return [(btn === 'create' && _vm.buttonCreateVisibe === true) ? [(_vm.crud === 'vds' && _vm.isAccess('service/create')) ? _c('span', {
      key: 'button-' + btn,
      ref: "buttonVdsCreate",
      refInFor: true,
      class: _vm.buttonsClass(btn),
      on: {
        "click": function($event) {
          return _vm.buttonsClick($event, btn)
        }
      }
    }, [_c('font-awesome-icon', {
      staticClass: "on-btn",
      attrs: {
        "icon": "plus"
      }
    }), _vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm._f("ftc")(button)) + "\n\t\t\t\t\t\t")], 1) : (_vm.crud === 'backups' && _vm.isAccess('service/create')) ? _c('span', {
      key: 'button-for-backups-' + btn,
      class: _vm.buttonsClass(btn),
      on: {
        "click": function($event) {
          return _vm.buttonsClick($event, btn)
        }
      }
    }, [_c('font-awesome-icon', {
      staticClass: "on-btn",
      attrs: {
        "icon": "plus"
      }
    }), _vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm._f("ftc")(button)) + "\n\t\t\t\t\t\t")], 1) : _c('router-link', {
      key: 'button-in-upper-block' + btn,
      class: _vm.buttonsClass(btn),
      attrs: {
        "to": _vm.buttonsUrl(btn)
      }
    }, [_c('font-awesome-icon', {
      staticClass: "on-btn",
      attrs: {
        "icon": "plus"
      }
    }), _vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm._f("ftc")(button)) + "\n\t\t\t\t\t\t")], 1)] : (btn === 'balance' && _vm.isAccess('operation/create')) ? _c('span', {
      key: 'button-' + btn,
      ref: "buttonBalance",
      refInFor: true,
      staticClass: "btn-client-balance",
      class: _vm.buttonsClass(btn),
      on: {
        "click": function($event) {
          return _vm.buttonsClick($event, btn)
        }
      }
    }, [_c('font-awesome-icon', {
      staticClass: "on-btn",
      attrs: {
        "icon": "plus"
      }
    }), _vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm._f("ftc")(button)) + "\n\t\t\t\t\t")], 1) : (btn === 'calculator') ? _c('span', {
      key: 'button-calc-' + btn,
      ref: "buttonCalculator",
      refInFor: true,
      staticClass: "btn-calc",
      class: _vm.buttonsClass(btn),
      attrs: {
        "title": _vm._f("ftc")('service/calculator')
      },
      on: {
        "click": function($event) {
          return _vm.buttonsClick($event, btn)
        }
      }
    }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm._f("ftc")('service/calculator')) + "\n\t\t\t\t\t")]) : (btn === 'transfer') ? [(_vm.crud === 'partner' && _vm.$store.state.user_balance) ? _c('div', {
      key: 'button-in-upper-block' + btn,
      staticClass: "w5-transfer-wrapper"
    }, [(_vm.crud === 'partner' && _vm.$store.state.user_balance) ? _c('span', {
      staticClass: "w5-partner-balance"
    }, [_c('span', [_vm._v(_vm._s(_vm._f("ftc")('operation/partner_balance')) + ": "), _c('Money', {
      staticClass: "font-weight-500",
      attrs: {
        "value": _vm.formater_FormatMoney(_vm.$store.state.user_balance.partner)
      }
    }), _vm._v(" "), _c('span', {
      directives: [{
        name: "withSafeTags",
        rawName: "v-withSafeTags",
        value: (_vm.localeFtc('main/ruble')),
        expression: "localeFtc('main/ruble')"
      }],
      staticClass: "font-weight-500"
    })], 1), _vm._v(" "), (_vm.clientPartnerData && 'total' in _vm.clientPartnerData && 'active' in _vm.clientPartnerData) ? _c('span', [_c('span', {
      directives: [{
        name: "withSafeTags",
        rawName: "v-withSafeTags",
        value: (_vm.localeFtc('partner/additional_info').replace('{total}', _vm.clientPartnerData.total).replace('{active}', _vm.clientPartnerData.active) + (_vm.clientPartnerData && 'last_year' in _vm.clientPartnerData ? (" (" + (_vm.clientPartnerData.last_year) + ")") : '')),
        expression: "localeFtc('partner/additional_info').replace('{total}', clientPartnerData.total).replace('{active}', clientPartnerData.active) + (clientPartnerData && 'last_year' in clientPartnerData ? ` (${clientPartnerData.last_year})` : '')"
      }]
    }), _vm._v(" "), _c('notice', {
      attrs: {
        "text": _vm._f("ftc")('partner/additional_info_notice'),
        "small": true
      }
    })], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.$store.state.user_balance && _vm.isAccess('operation/convert')) ? _c('span', [_c('span', {
      staticClass: "margin-right-10",
      class: _vm.buttonsClass(btn),
      attrs: {
        "disabled": !_vm.clientPartnerData || !('total' in _vm.clientPartnerData) || _vm.clientPartnerData.total == 0
      },
      on: {
        "click": _vm.clientToOperationHistory
      }
    }, [_c('font-awesome-icon', {
      staticClass: "on-btn",
      attrs: {
        "icon": "dollar-sign"
      }
    }), _vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("ftc")('operation/operations')) + "\n\t\t\t\t\t\t\t\t")], 1), _vm._v(" "), _c('span', {
      key: 'button-' + btn,
      class: _vm.buttonsClass(btn),
      attrs: {
        "disabled": _vm.$store.state.user_balance.partner == 0
      },
      on: {
        "click": function($event) {
          return _vm.buttonsClick($event, btn)
        }
      }
    }, [_c('font-awesome-icon', {
      staticClass: "on-btn",
      attrs: {
        "icon": "exchange-alt"
      }
    }), _vm._v("\n\t\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("ftc")(button)) + "\n\t\t\t\t\t\t\t\t")], 1)]) : _vm._e()]) : _vm._e()] : [(_vm.buttons[btn] && _vm.buttons[btn]['visible'] && (btn === 'r_on' || btn === 'r_off')) ? _c('font-awesome-icon', {
      key: 'button-in-upper-block-' + btn,
      staticClass: "pull-right",
      class: _vm.buttonsClass(btn),
      attrs: {
        "icon": _vm.buttons[btn]['icone'],
        "title": _vm.buttons[btn]['active'] && _vm.buttons[btn]['title'] ? _vm.localeFtc(_vm.buttons[btn]['title']) : null,
        "transform": _vm.buttons[btn]['icone'] === 'stop' ? 'grow-2' : null,
        "fixed-width": ""
      },
      on: {
        "click": function($event) {
          return _vm.buttonsClick($event, btn)
        }
      }
    }) : (_vm.buttons[btn] && _vm.buttons[btn]['visible'] && (btn === 'ip_on' || btn === 'ip_off')) ? _c('font-awesome-icon', {
      key: 'button-in-upper-block-for-ip-' + btn,
      staticClass: "pull-right",
      class: _vm.buttonsClass(btn),
      attrs: {
        "icon": _vm.buttons[btn]['icone'],
        "title": _vm.buttons[btn]['active'] && _vm.buttons[btn]['title'] ? _vm.localeFtc(_vm.buttons[btn]['title']) : null,
        "transform": _vm.buttons[btn]['icone'] === 'stop' ? 'grow-2' : null,
        "fixed-width": ""
      },
      on: {
        "click": function($event) {
          return _vm.buttonsClick($event, btn)
        }
      }
    }) : (_vm.buttons[btn] && _vm.buttons[btn]['visible'] && btn === 'blockTicket') ? _c('font-awesome-layers', {
      key: 'button-in-upper-block-for-tickets-' + btn,
      staticClass: "pull-right",
      class: _vm.buttonsClass(btn),
      attrs: {
        "title": _vm.buttons[btn]['active'] && _vm.buttons[btn]['title'] ? _vm.localeFtc(_vm.buttons[btn]['title']) : null
      },
      on: {
        "click": function($event) {
          return _vm.buttonsClick($event, btn)
        }
      }
    }, [_c('font-awesome-icon', {
      attrs: {
        "icon": "circle",
        "fixed-width": "",
        "transform": "grow-1"
      }
    }), _vm._v(" "), _c('font-awesome-icon', {
      attrs: {
        "icon": "times",
        "fixed-width": "",
        "transform": "shrink-6"
      }
    })], 1) : (_vm.buttons[btn] && _vm.buttons[btn]['visible'] && btn === 'closeTicket') ? _c('font-awesome-icon', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.showCloseTicketButton),
        expression: "showCloseTicketButton"
      }],
      key: 'button-in-upper-block-for-tickets-close-' + btn,
      staticClass: "pull-right",
      class: _vm.buttonsClass(btn),
      attrs: {
        "icon": _vm.buttons[btn]['icone'],
        "title": _vm.buttons[btn]['active'] && _vm.buttons[btn]['title'] ? _vm.localeFtc(_vm.buttons[btn]['title']) + '!!!' : null,
        "transform": _vm.buttons[btn]['icone'] === 'stop' ? 'grow-2' : null,
        "fixed-width": ""
      },
      on: {
        "click": function($event) {
          return _vm.buttonsClick($event, btn)
        }
      }
    }) : (_vm.buttons[btn] && _vm.buttons[btn]['visible']) ? _c('font-awesome-icon', {
      key: 'button-in-upper-block-other-' + btn,
      staticClass: "pull-right",
      class: _vm.buttonsClass(btn),
      attrs: {
        "icon": _vm.buttons[btn]['icone'],
        "title": _vm.buttons[btn]['active'] && _vm.buttons[btn]['title'] ? _vm.localeFtc(_vm.buttons[btn]['title']) : null,
        "transform": _vm.buttons[btn]['icone'] === 'stop' ? 'grow-2' : null,
        "fixed-width": ""
      },
      on: {
        "click": function($event) {
          return _vm.buttonsClick($event, btn)
        }
      }
    }) : _vm._e()]]
  }), _vm._v(" "), _c('span', {
    staticClass: "clearfix"
  })], 2) : _vm._e(), _vm._v(" "), (_vm.listData && _vm.linkHint && _vm.linkHint.position === 'before-list') ? _c('div', {
    staticClass: "w5-info-link"
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "link"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.linkHint.link,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.linkHint.title)))]), _vm._v(" "), (_vm.linkHint.afterText) ? _c('span', {
    staticClass: "font-weight-500"
  }, [_vm._v(" " + _vm._s(_vm._f("ftc")(_vm.linkHint.afterText)))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.listData) ? _c('div', {
    class: _vm.table_Loading ? 'w5-table-wrapper-loading' : 'w5-table-wrapper'
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.buildTableSpiner),
      expression: "buildTableSpiner"
    }],
    staticClass: "ajax-backdrop-loader"
  }, [_c('img', {
    attrs: {
      "src": _vm.stylePathToLoader || '/static/img/loader.gif'
    }
  }), _c('span', [_vm._v(_vm._s(_vm._f("ftc")('main/table_rendering')))])]), _vm._v(" "), _c('table', [_c('thead', [_c('tr', [_vm._l((_vm.listConfig['columns']), function(col, c) {
    return [(_vm.verifyForGlobalFilter(c)) ? _c('th', {
      key: 'col-' + c,
      class: col['class-col'] ? col['class-col'] : false,
      style: (col['style-col'] ? col['style-col'] : false)
    }, [(_vm.isColumnInData(c) && c !== 'ticket_label') ? _c('span', {
      class: {
        'w5-column-sort': col['sort'] === true
      },
      on: {
        "click": function($event) {
          return _vm.sortTable(c, col)
        }
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("ftc")(col['title'] ? col['title'] : _vm.listData.columns[c])) + "\n\t\t\t\t\t\t\t\t\t")]) : _vm._e()]) : _vm._e()]
  }), _vm._v(" "), (_vm.listConfig['opers'] || _vm.listConfig['oneOper']) ? _c('th', {
    staticClass: "w5-column-opers",
    style: (_vm.listConfig['oneOper'] ? ('width: ' + (_vm.listConfig['oneOper']['columnWidth'] ? _vm.listConfig['oneOper']['columnWidth'] : '26px')) : '')
  }, [_vm._v(" ")]) : _vm._e()], 2)]), _vm._v(" "), _c('tbody', {
    attrs: {
      "data-crud": _vm.crud,
      "data-user": this.$store.state.user_type
    }
  }, [_vm._l((_vm.renderRows), function(row, index) {
    return _c('tr', {
      key: 'row-' + row[_vm.listConfig['column_id']],
      class: {
        'w5-list-selected-row': row['w5-row-selected'] === true, 'w5-table-last-worked-record': row[_vm.listConfig['column_id']] == _vm.lastWorkedRowID
      },
      on: {
        "click": function($event) {
          return _vm.selectRowInTable($event, row[_vm.listConfig['column_id']])
        }
      }
    }, [_vm._l((_vm.listConfig['columns']), function(col, c) {
      return [(_vm.isColumnInData(c)) ? _c('td', {
        key: 'cell-' + row[_vm.listConfig['column_id']] + '_' + c,
        class: _vm.cellClass(c, col),
        style: (col['style-row'] ? col['style-row'] : false),
        attrs: {
          "aria-label": _vm.localeFtc(col['title'] ? col['title'] : _vm.listData.columns[c])
        }
      }, [_c('span', {
        staticClass: "w5-table-cell"
      }, [(('server_view_type' in row) && (c === 'server' || c === 'server_name')) ? _c('span', {
        class: 'color-type-' + String(row['server_view_type']),
        staticStyle: {
          "font-size": "13px"
        }
      }, [_vm._v("●")]) : _vm._e(), _vm._v(" "), (col['online-status-before']) ? _c('span', {
        staticClass: "online-status-before",
        class: {
          active: row[col['online-status-before']] === true
        }
      }, [_vm._v(" ●")]) : _vm._e(), _vm._v(" "), (col['component-row'] === 'linkComponent') ? [(_vm.$store.state.user_type === 'admin' && !_vm.accountGlobalFilter && (c === 'account_name' || c === 'owner_account_name') && row[c] && (row['account_id'] || row['owner_account_id']) && String(row[c]).trim() !== '' && _vm.crud !== 'iphistory') ? _c('font-awesome-icon', {
        staticClass: "global-filter-button",
        attrs: {
          "title": _vm._f("ftc")('account/filter'),
          "icon": "filter"
        },
        on: {
          "click": function($event) {
            return _vm.setAccountGlobalFilter(row, c)
          }
        }
      }) : _vm._e(), _vm._v(" "), (_vm.$store.state.user_type === 'admin' && !_vm.accountGlobalFilter && _vm.crud === 'logs' && c === 'user_email' && row['account_name'] && row['account_id'] && String(row['account_name']).trim() !== '') ? _c('font-awesome-icon', {
        staticClass: "global-filter-button",
        attrs: {
          "title": _vm._f("ftc")('account/filter'),
          "icon": "filter"
        },
        on: {
          "click": function($event) {
            return _vm.setAccountGlobalFilter(row)
          }
        }
      }) : _vm._e(), _vm._v(" "), (_vm.crud == 'rackdevice' && (!_vm.crudFilter || !_vm.crudFilter.crud != 'rackdevice' || !_vm.crudFilter.field != 'rack_id') && c === 'rack_name' && row[c] && String(row[c]).trim() !== '') ? _c('font-awesome-icon', {
        staticClass: "global-filter-button",
        attrs: {
          "title": _vm._f("ftc")('account/filter'),
          "icon": "filter"
        },
        on: {
          "click": function($event) {
            return _vm.GoTo(row, 'rackdevice', '', 'rack_id')
          }
        }
      }) : _vm._e(), _vm._v(" "), _c('linkComponent', {
        directives: [{
          name: "highlightFastSearch",
          rawName: "v-highlightFastSearch",
          value: (_vm.fastSearchValue),
          expression: "fastSearchValue"
        }],
        class: col['function-cell-class'] ? col['function-cell-class'](row) : false,
        attrs: {
          "url": col['component-param-url'](row, _vm.listData),
          "text": col['component-param-text'] ? col['component-param-text'](row, _vm.listData) : row[c],
          "fontawesomeicon": col['component-param-icon'] ? col['component-param-icon'](row) : null,
          "flagicon": col['component-param-flagicon'] ? col['component-param-flagicon'](row) : null,
          "status": col['component-param-statusService'] ? col['component-param-statusService'](row) : false,
          "statusText": col['component-param-statusServiceText'] ? col['component-param-statusServiceText'](row) : false,
          "srcData": row
        }
      })] : (col['component-row'] === 'image') ? _c('img', {
        class: /vds$/.test(_vm.crud) ? 'vds' : _vm.crud,
        attrs: {
          "alt": row['service_data'] && row['service_data']['template'] && row['service_data']['template']['name'] ? String(row['service_data']['template']['name']) : false,
          "title": row['service_data'] && row['service_data']['template'] && row['service_data']['template']['name'] ? _vm.localeFtc(String(row['service_data']['template']['name'])) : false,
          "src": col['component-param-url'](row, _vm.listData)
        }
      }) : (col['component-row'] === 'imageGroupVds') ? _c('img', {
        staticClass: "vds-group",
        attrs: {
          "title": _vm.localeFtc(col['component-param-title'](row, _vm.listData)),
          "src": col['component-param-url'](row)
        }
      }) : (col['component-row'] === 'vds_info') ? _c('span', {
        staticClass: "w5-list-vds"
      }, [_c('span', {
        staticClass: "flag-icon",
        class: 'flag-icon-' + col['component-param-flag'](row, _vm.listData),
        attrs: {
          "alt": col['component-param-flag-name'](row, _vm.listData),
          "title": _vm.localeFtc(col['component-param-flag-name'](row, _vm.listData))
        }
      }), _vm._v(" "), _c('linkComponent', {
        directives: [{
          name: "highlightFastSearch",
          rawName: "v-highlightFastSearch",
          value: (_vm.fastSearchValue),
          expression: "fastSearchValue"
        }],
        staticClass: "w5-vds-view-link linkified",
        attrs: {
          "url": col['component-param-url'](row),
          "text": col['component-param-text'] ? col['component-param-text'](row, _vm.listData) : row[c],
          "status": col['component-param-statusService'] ? col['component-param-statusService'](row) : false,
          "statusText": col['component-param-statusServiceText'] ? col['component-param-statusServiceText'](row) : false
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "w5-vds-data-info"
      }, [_vm._v(_vm._s(col['component-param-data'](row)))])], 1) : (col['component-row'] === 'backup_name') ? _c('span', {
        staticClass: "w5-list-backup"
      }, [_c('span', {
        staticClass: "flag-icon",
        class: 'flag-icon-' + col['component-param-flag'](row, _vm.listData),
        attrs: {
          "alt": _vm.localeFtc(col['component-param-flag-name'](row, _vm.listData)),
          "title": _vm.localeFtc(col['component-param-flag-name'](row, _vm.listData))
        }
      }), _vm._v(" "), _c('linkComponent', {
        directives: [{
          name: "highlightFastSearch",
          rawName: "v-highlightFastSearch",
          value: (_vm.fastSearchValue),
          expression: "fastSearchValue"
        }],
        staticClass: "w5-backup-view-link linkified",
        attrs: {
          "url": col['component-param-url'](row),
          "text": col['component-param-text'] ? col['component-param-text'](row, _vm.listData) : row[c],
          "status": col['component-param-statusService'] ? col['component-param-statusService'](row) : false,
          "statusText": col['component-param-statusServiceText'] ? col['component-param-statusServiceText'](row) : false
        }
      })], 1) : (col['component-row'] === 'iso_info') ? _c('div', {
        staticClass: "w5-list-iso"
      }, [(row['service_data'] && row['service_data']['iso'] && row['service_data']['iso']['attached'] === true) ? [(!row['service_status_text']) ? _c('button', {
        staticClass: "btn btn-default w5-eject-iso-button",
        attrs: {
          "title": _vm._f("ftc")('service/iso_eject')
        },
        on: {
          "click": function($event) {
            return _vm.ejectISO(row, $event)
          }
        }
      }, [_c('font-awesome-icon', {
        attrs: {
          "icon": "eject"
        }
      })], 1) : _vm._e(), _vm._v("  \n\t\t\t\t\t\t\t\t\t\t\t\t"), _c('div', {
        staticClass: "hidden-ellipsis"
      }, [_c('linkComponent', {
        attrs: {
          "url": '/vds/view/' + row['parent_id'],
          "text": row['parent_name']
        }
      })], 1)] : _c('span', [_vm._v(_vm._s(_vm._f("lower")(_vm._f("ftc")('main/no'))))])], 2) : (col['component-row'] === 'outer_disk_info') ? _c('div', {
        staticClass: "w5-list-iso"
      }, [(row['service_data'] && row['service_data']['extdisk'] && row['service_data']['extdisk']['attached'] === true) ? [(!row['service_status_text']) ? _c('button', {
        staticClass: "btn btn-default w5-eject-iso-button",
        attrs: {
          "title": _vm._f("ftc")('main/detach')
        },
        on: {
          "click": function($event) {
            return _vm.ejectOuterDiskFromTable(row, $event)
          }
        }
      }, [_c('font-awesome-icon', {
        attrs: {
          "icon": "eject"
        }
      })], 1) : _vm._e(), _vm._v("  \n\t\t\t\t\t\t\t\t\t\t\t\t"), _c('div', {
        staticClass: "hidden-ellipsis"
      }, [_c('linkComponent', {
        attrs: {
          "url": '/vds/view/' + row['parent_id'],
          "text": row['parent_name']
        }
      })], 1)] : _c('span', [_vm._v(_vm._s(_vm._f("lower")(_vm._f("ftc")('main/no'))))])], 2) : (col['component-row'] === 'note_info') ? _c('span', {
        staticClass: "w5-list-note"
      }, [_c('span', [_vm._v(_vm._s(col['component-param-date'](row)))]), _vm._v(" "), (row['account_name']) ? [_c('br'), _vm._v(" "), (_vm.$store.state.user_type === 'admin' && !_vm.accountGlobalFilter && row['account_name'] && row['account_id'] && String(row['account_name']).trim() !== '') ? _c('font-awesome-icon', {
        staticClass: "global-filter-button",
        attrs: {
          "title": _vm._f("ftc")('account/filter'),
          "icon": "filter"
        },
        on: {
          "click": function($event) {
            return _vm.setAccountGlobalFilter(row)
          }
        }
      }) : _vm._e(), _vm._v(" "), _c('linkComponent', {
        directives: [{
          name: "highlightFastSearch",
          rawName: "v-highlightFastSearch",
          value: (_vm.fastSearchValue),
          expression: "fastSearchValue"
        }],
        attrs: {
          "url": col['component-param-url1'](row),
          "text": col['component-param-text1'] ? col['component-param-text1'](row, _vm.listData) : row[c]
        }
      })] : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('linkComponent', {
        directives: [{
          name: "highlightFastSearch",
          rawName: "v-highlightFastSearch",
          value: (_vm.fastSearchValue),
          expression: "fastSearchValue"
        }],
        attrs: {
          "url": col['component-param-url2'](row),
          "text": col['component-param-text2'] ? col['component-param-text2'](row, _vm.listData) : row[c]
        }
      })], 2) : (col['component-row'] === 'partner_code' && row[c] !== null && row[c] !== undefined) ? _c('span', {
        staticClass: "w5-list-p2a"
      }, [(row['status'] === false) ? _c('span', {
        staticClass: "btn btn-submit btn-submut-extra-small",
        on: {
          "click": function($event) {
            return _vm.partnerActivate(row)
          }
        }
      }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("ftc")('main/activate')) + "\n\t\t\t\t\t\t\t\t\t\t")]) : _c('a', {
        staticClass: "linkified",
        attrs: {
          "href": _vm.AppServerUrl + '/?partner=' + row[c],
          "target": "_blank"
        }
      }, [_c('span', {
        directives: [{
          name: "highlightFastSearch",
          rawName: "v-highlightFastSearch",
          value: (_vm.fastSearchValue),
          expression: "fastSearchValue"
        }]
      }, [_vm._v(_vm._s(_vm.AppServerUrl + '/?partner=' + row[c]))])])]) : (col['component-row'] === 'http_referer' && row[c] !== null && row[c] !== undefined) ? _c('span', {
        staticClass: "w5-http-referer"
      }, [_c('a', {
        attrs: {
          "href": row[c],
          "target": "_blank"
        }
      }, [_vm._v(_vm._s(row[c]))])]) : (col['component-row'] === 'document_html') ? [(row['html'] !== null && row['html'] !== undefined) ? _c('span', {
        staticClass: "w5-http-referer",
        on: {
          "click": function($event) {
            $event.stopPropagation();
          }
        }
      }, [_c('span', {
        staticClass: "w5-modal-link",
        staticStyle: {
          "font-weight": "500"
        },
        on: {
          "click": function($event) {
            return _vm.openDocumentModalDialog(row['html'], row['pdf'], row['xml'])
          }
        }
      }, [_vm._v(_vm._s(row[c]))]), _vm._v(" "), (row['payer_id'] && row['payer_name']) ? [_c('br'), _vm._v(" "), _c('linkComponent', {
        directives: [{
          name: "highlightFastSearch",
          rawName: "v-highlightFastSearch",
          value: (_vm.fastSearchValue),
          expression: "fastSearchValue"
        }],
        attrs: {
          "url": '/payer/view/' + row['payer_id'],
          "text": row['payer_name']
        }
      })] : _vm._e()], 2) : _c('linkComponent', {
        directives: [{
          name: "highlightFastSearch",
          rawName: "v-highlightFastSearch",
          value: (_vm.fastSearchValue),
          expression: "fastSearchValue"
        }],
        attrs: {
          "url": '/document/view/' + row['document_id'],
          "text": row[c]
        },
        on: {
          "click": function($event) {
            $event.stopPropagation();
          }
        }
      })] : (col['component-row'] === 'formated_number' && row[c] !== null && row[c] !== undefined) ? _c('span', {
        staticClass: "w5-format-number",
        class: col['component-param-cell-class'] ? col['component-param-cell-class'](row) : false
      }, [_c('Money', {
        attrs: {
          "value": col['component-param-cell'](row, _vm.countDigits)
        }
      })], 1) : (col['component-row'] === 'status_info') ? _c('span', {
        staticClass: "w5-list-status",
        class: col['function-cell-class'] ? col['function-cell-class'](row) : false
      }, [(col['function-row'](row, _vm.listData)['loader']) ? [_c('div', [_c('span', {
        staticStyle: {
          "white-space": "normal"
        }
      }, [_vm._v(_vm._s(col['function-row'](row, _vm.listData)['status']))]), _vm._v(" "), _c('img', {
        staticStyle: {
          "margin-left": "6px"
        },
        attrs: {
          "src": require("../../assets/img/loading-hor16.gif")
        }
      })])] : (col['function-row'](row, _vm.listData)['timer']) ? [_c('div', [_c('span', {
        staticStyle: {
          "white-space": "normal"
        }
      }, [_vm._v(_vm._s(col['function-row'](row, _vm.listData)['status']))]), _vm._v(" "), _c('font-awesome-icon', {
        staticStyle: {
          "margin-left": "6px"
        },
        attrs: {
          "icon": "clock"
        }
      })], 1)] : _c('span', {
        staticStyle: {
          "white-space": "normal",
          "word-break": "break-word"
        }
      }, [_vm._v(_vm._s(col['function-row'](row, _vm.listData)['status']))]), _vm._v(" "), (_vm.vdsCloneVdsInProcess(row['service_id'])) ? _c('div', {
        staticClass: "vds-clone-status-in-table"
      }, [_c('font-awesome-layers', {
        staticClass: "vds-clone-status",
        on: {
          "click": function($event) {
            $event.stopPropagation();
            return _vm.vdsCloneShowProcessData(row['service_id'])
          }
        }
      }, [_c('font-awesome-icon', {
        attrs: {
          "icon": "server"
        }
      }), _vm._v(" "), _c('font-awesome-icon', {
        attrs: {
          "icon": "clone"
        }
      })], 1), _vm._v(" "), (_vm.vdsCloneVdsInProcess(row['service_id']).error) ? _c('font-awesome-icon', {
        staticClass: "error",
        attrs: {
          "icon": "exclamation-circle"
        },
        on: {
          "click": function($event) {
            $event.stopPropagation();
            return _vm.vdsCloneShowProcessData(row['service_id'])
          }
        }
      }) : _c('img', {
        attrs: {
          "src": require("../../assets/img/loading-hor16.gif")
        }
      })], 1) : _vm._e()], 2) : (col['component-row'] === 'CrudListFilter' && col['component-param-src-field'] && col['component-param-crud'] && col['component-param-filter-field']) ? _c('span', {
        staticClass: "w5-link",
        on: {
          "click": function($event) {
            $event.stopPropagation();
            return _vm.GoTo(row, col['component-param-crud'], col['component-param-object'], col['component-param-filter-field'])
          }
        }
      }, [(col['function-row']) ? [_vm._v(_vm._s(col['function-row'](row, _vm.listData)))] : [_vm._v(_vm._s(row[col['component-param-src-field']]))]], 2) : (col['component-row'] === 'ticket_label') ? [(row['ticket_label'] === 'loading') ? _c('div', {
        staticStyle: {
          "height": "23px"
        }
      }, [_c('img', {
        attrs: {
          "src": require("../../assets/img/loading-hor16.gif")
        }
      })]) : _c('div', {
        ref: 'ticket-label-' + row['ticket_id'],
        refInFor: true,
        staticClass: "w5-list-ticket-label",
        class: col['function-cell-class'] ? col['function-cell-class'](row) : false,
        style: (col['function-cell-style'] ? col['function-cell-style'](row) : false),
        on: {
          "click": function($event) {
            $event.stopPropagation();
            return _vm.changeTicketLabel(row)
          }
        }
      })] : (col['component-row'] === 'ticket_read') ? [('message_unread_count' in row && row['message_unread_count'] > 0) ? _c('font-awesome-layers', {
        staticClass: "ticket-read"
      }, [_c('font-awesome-icon', {
        attrs: {
          "icon": "envelope"
        }
      }), _vm._v(" "), _c('font-awesome-icon', {
        attrs: {
          "icon": "asterisk"
        }
      })], 1) : _c('font-awesome-layers', {
        staticClass: "ticket-read"
      }, [_c('font-awesome-icon', {
        attrs: {
          "icon": "envelope"
        }
      }), _vm._v(" "), _c('font-awesome-icon', {
        attrs: {
          "icon": "check"
        }
      })], 1)] : (col['component-row'] === 'service_type_cost') ? [(col['function-row'](row, _vm.listData)['cost']) ? _c('span', [_c('Money', {
        attrs: {
          "value": col['function-row'](row, _vm.listData)['cost']
        }
      }), _vm._v(" "), _c('span', {
        domProps: {
          "innerHTML": _vm._s(_vm.localeFtc('main/ruble'))
        }
      })], 1) : _vm._e(), _vm._v(" "), (col['function-row'](row, _vm.listData)['cost'] && col['function-row'](row, _vm.listData)['for']) ? _c('span', [_vm._v("/")]) : _vm._e(), _vm._v(" "), (col['function-row'](row, _vm.listData)['for']) ? _c('span', [_vm._v(_vm._s(col['function-row'](row, _vm.listData)['for']))]) : _vm._e(), _vm._v(" "), (col['function-row'](row, _vm.listData)['for'] && col['function-row'](row, _vm.listData)['period']) ? _c('span', [_vm._v("/")]) : _vm._e(), _vm._v(" "), (col['function-row'](row, _vm.listData)['period']) ? _c('span', [_vm._v(_vm._s(col['function-row'](row, _vm.listData)['period']))]) : _vm._e()] : (col['component-row'] === 'plan_cost') ? [_c('Money', {
        attrs: {
          "value": col['function-row'](row, _vm.listData)['cost']
        }
      }), _vm._v(" "), _c('span', {
        domProps: {
          "innerHTML": _vm._s(_vm.localeFtc('main/ruble'))
        }
      }), _vm._v(" / " + _vm._s(col['function-row'](row, _vm.listData)['period']) + "\n\t\t\t\t\t\t\t\t\t")] : (col['component-row'] === 'ticket_subject') ? [_c('linkComponent', {
        directives: [{
          name: "highlightFastSearch",
          rawName: "v-highlightFastSearch",
          value: (_vm.fastSearchValue),
          expression: "fastSearchValue"
        }],
        attrs: {
          "url": '/ticket/view/' + row['ticket_id'],
          "text": row['ticket_subject']
        }
      }), _vm._v(" "), (_vm.$store.state.user_type === 'admin' && row['message_count'] > 0) ? _c('span', {
        staticClass: "badge ticket-message-count-badge admin margin-left-6",
        on: {
          "mouseover": function($event) {
            return _vm.ticketLastCommentatorShow(row, $event)
          },
          "mouseleave": function($event) {
            return _vm.ticketLastCommentatorHide()
          }
        }
      }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(row['message_count']) + "\n\t\t\t\t\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.$store.state.user_type === 'client' && row['message_unread_count'] > 0) ? _c('span', {
        staticClass: "badge ticket-message-count-badge margin-left-6"
      }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(row['message_unread_count']) + "\n\t\t\t\t\t\t\t\t\t\t")]) : _vm._e()] : (col['component-row'] === 'server_groups' && row[c] !== null && row[c] !== undefined && Array.isArray(row[c])) ? _c('span', {
        staticClass: "w5-list-groups"
      }, [_vm._l((row[c]), function(server, s) {
        return [(s > 0) ? _c('span', {
          key: 'del-grp-' + s
        }, [_vm._v(", ")]) : _vm._e(), _vm._v(" "), _c('linkComponent', {
          directives: [{
            name: "highlightFastSearch",
            rawName: "v-highlightFastSearch",
            value: (_vm.fastSearchValue),
            expression: "fastSearchValue"
          }],
          key: 'server_group_' + s,
          attrs: {
            "url": '/servergroup/view/' + server['group_id'],
            "text": server['group_name']
          }
        })]
      })], 2) : (col['component-row'] === 'server_groups_view' && row[c] !== null && row[c] !== undefined && row['server_group_id'] && row['server_group_name']) ? _c('span', {
        staticClass: "w5-list-groups"
      }, [_c('linkComponent', {
        directives: [{
          name: "highlightFastSearch",
          rawName: "v-highlightFastSearch",
          value: (_vm.fastSearchValue),
          expression: "fastSearchValue"
        }],
        attrs: {
          "url": '/servergroup/view/' + row['server_group_id'],
          "text": row['server_group_name']
        }
      })], 1) : (col['component-row'] === 'plan_groups_view' && row[c] !== null && row[c] !== undefined && row['plan_group_id'] && row['plan_group_name']) ? _c('span', {
        staticClass: "w5-list-groups"
      }, [_c('linkComponent', {
        directives: [{
          name: "highlightFastSearch",
          rawName: "v-highlightFastSearch",
          value: (_vm.fastSearchValue),
          expression: "fastSearchValue"
        }],
        attrs: {
          "url": '/plangroup/view/' + row['plan_group_id'],
          "text": row['plan_group_name']
        }
      })], 1) : (col['component-row'] === 'template_groups_view' && row[c] !== null && row[c] !== undefined && row['template_group_id'] && row['template_group_name']) ? _c('span', {
        staticClass: "w5-list-groups"
      }, [_c('linkComponent', {
        directives: [{
          name: "highlightFastSearch",
          rawName: "v-highlightFastSearch",
          value: (_vm.fastSearchValue),
          expression: "fastSearchValue"
        }],
        attrs: {
          "url": '/templategroup/view/' + row['template_group_id'],
          "text": row['template_group_name']
        }
      })], 1) : (col['component-row'] === 'admin_roles' && row[c] !== null && row[c] !== undefined && Array.isArray(row[c])) ? _c('span', {
        staticClass: "w5-list-roles"
      }, _vm._l((row[c]), function(role, r) {
        return _c('span', {
          directives: [{
            name: "highlightFastSearch",
            rawName: "v-highlightFastSearch",
            value: (_vm.fastSearchValue),
            expression: "fastSearchValue"
          }],
          key: 'admin_roles_' + r
        }, [(r > 0) ? _c('span', [_vm._v(",")]) : _vm._e(), _vm._v("\n\t\t\t\t\t\t\t\t\t\t\t " + _vm._s(_vm._f("ftc")(role)))])
      }), 0) : (col['component-row'] === 'operation_status') ? [(_vm.$store.state.user_type === 'client' && row['operation_status'] === 0 && row['can_pay'] === true) ? _c('linkComponent', {
        staticClass: "btn btn-submit btn-submut-extra-small",
        attrs: {
          "url": '/operation/select/' + row['operation_id'],
          "text": _vm._f("lower")(_vm._f("ftc")('operation/pay'))
        }
      }) : _c('span', {
        directives: [{
          name: "highlightFastSearch",
          rawName: "v-highlightFastSearch",
          value: (_vm.fastSearchValue),
          expression: "fastSearchValue"
        }],
        class: col['component-param-cell-class'] ? col['component-param-cell-class'](row) : false
      }, [_vm._v(_vm._s(col['component-param-data'](row, _vm.listData)))])] : (col['function-row']) ? _c('span', {
        directives: [{
          name: "highlightFastSearch",
          rawName: "v-highlightFastSearch",
          value: (_vm.fastSearchValue),
          expression: "fastSearchValue"
        }],
        class: col['function-cell-class'] ? col['function-cell-class'](row) : false
      }, [(col['function-flagicon']) ? _c('span', {
        staticClass: "flag-icon",
        class: col['function-flagicon'](row)
      }) : _vm._e(), _vm._v(_vm._s(col['function-row'](row, _vm.listData, _vm.localeFtc)))]) : (col['formater-row']) ? _c('span', {
        directives: [{
          name: "highlightFastSearch",
          rawName: "v-highlightFastSearch",
          value: (_vm.fastSearchValue),
          expression: "fastSearchValue"
        }],
        class: col['function-cell-class'] ? col['function-cell-class'](row) : false,
        style: (col['function-cell-style'] ? col['function-cell-style'](row) : false)
      }, [_vm._v(_vm._s(_vm.formater(col['formater-row'], row[c])))]) : _c('span', {
        directives: [{
          name: "highlightFastSearch",
          rawName: "v-highlightFastSearch",
          value: (_vm.fastSearchValue),
          expression: "fastSearchValue"
        }],
        class: col['function-cell-class'] ? col['function-cell-class'](row) : false,
        style: (col['function-cell-style'] ? col['function-cell-style'](row) : false)
      }, [_vm._v(_vm._s(_vm._f("ftc")(row[c])))]), _vm._v(" "), (col['user-online-status'] && row[col['user-online-status']] === true) ? _c('span', {
        staticClass: "online-status-is-on"
      }, [_vm._v(" ●")]) : _vm._e(), _vm._v(" "), (col['domain-online-status'] && col['domain-online-status'](row)) ? _c('span', {
        staticClass: "online-status-is-on"
      }, [_vm._v(" ●")]) : _vm._e()], 2)]) : _vm._e()]
    }), _vm._v(" "), (_vm.listConfig['opers']) ? _c('td', {
      staticClass: "w5-column-opers"
    }, [_c('dropDownButton', {
      attrs: {
        "dataConfig": _vm.listConfig['opers'],
        "row": row,
        "index": index,
        "crud": _vm.crud
      },
      on: {
        "action": _vm.actionOperButton
      }
    })], 1) : _vm._e(), _vm._v(" "), (_vm.listConfig['oneOper']) ? _c('td', {
      staticClass: "w5-column-opers"
    }, [_c('oneOperButton', {
      attrs: {
        "dataConfig": _vm.listConfig['oneOper'],
        "row": row,
        "index": index,
        "crud": _vm.crud
      },
      on: {
        "action": _vm.actionOperButton
      }
    })], 1) : _vm._e()], 2)
  }), _vm._v(" "), (_vm.listData && _vm.listData.rows && _vm.listData.rows.length && _vm.crud === 'operation' && 'totalSumm' in _vm.listData) ? _c('tr', [_c('td', {
    staticClass: "text-right",
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('operation/total_summ')) + ":  \n\t\t\t\t\t\t\t\t"), _c('span', {
    staticClass: "font-weight-500",
    class: {
      'color-red': _vm.listData.totalSumm < 0
    }
  }, [_c('Money', {
    attrs: {
      "value": _vm.totalSummFormat(_vm.listData.totalSumm)
    }
  })], 1)]), _vm._v(" "), _c('td', {
    staticClass: "padding-left-0 font-weight-500",
    class: {
      'color-red': _vm.listData.totalSumm < 0
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.localeFtc('main/ruble'))
    }
  })]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": this.$store.state.user_type !== 'client' ? (_vm.$store.state.accountGlobalFilter ? 3 : 4) : 2
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.listData && _vm.listData.rows && _vm.listData.rows.length && _vm.crud === 'partneractions' && 'totalSumm' in _vm.listData) ? _c('tr', [_c('td', {
    staticClass: "text-right",
    attrs: {
      "colspan": _vm.$store.state.accountGlobalFilter ? 6 : 7
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('operation/total_summ')) + ":  \n\t\t\t\t\t\t\t\t"), _c('span', {
    staticClass: "font-weight-500",
    class: {
      'color-red': _vm.listData.totalSumm < 0
    }
  }, [_c('Money', {
    attrs: {
      "value": _vm.totalSummFormat(_vm.listData.totalSumm)
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "font-weight-500",
    class: {
      'color-red': _vm.listData.totalSumm < 0
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.localeFtc('main/ruble'))
    }
  })])])]) : _vm._e(), _vm._v(" "), _c('tr', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.listData && _vm.listData.rows && _vm.listData.rows.length === 0),
      expression: "listData && listData.rows && listData.rows.length === 0"
    }]
  }, [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": Object.keys(_vm.listConfig['columns']).length + (_vm.listConfig['opers'] ? 1 : 0)
    }
  }, [_c('img', {
    staticClass: "w5-empty-table-img",
    attrs: {
      "src": require("../../assets/img/puzzle.png")
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "font-size-110 w5-empty-table-hint"
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/empty_table')))])])])], 2)])]) : _vm._e(), _vm._v(" "), (_vm.listData && _vm.listData.rows && _vm.listData.rows.length) ? _c('div', {
    staticClass: "margin-15-0"
  }, [(_vm.listData && _vm.listData.rows && _vm.listData.rows.length) ? _c('span', {
    staticClass: "font-size-80 font-weight-500 list-total"
  }, [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm._f("ftc")('main/list_total')) + ":\n\t\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.listData && _vm.listData.rows && _vm.listData.rows.length) ? _c('span', {
    staticClass: "font-size-80 list-total"
  }, [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.listData.totalCount) + "\n\t\t\t\t")]) : _vm._e(), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.totalSelectedRowsCount && _vm.totalSelectedRowsCount > 0),
      expression: "totalSelectedRowsCount && totalSelectedRowsCount > 0"
    }]
  }, [_vm._v("\n\t\t\t\t\t, "), _c('span', {
    staticClass: "font-size-80 font-weight-500"
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/selected')) + ":")]), _vm._v(" "), _c('span', {
    staticClass: "font-size-80"
  }, [_vm._v(_vm._s(_vm.totalSelectedRowsCount))])]), _vm._v(" "), _c('span', {
    staticClass: "widget-page-size"
  }, [_c('span', {
    staticClass: "font-size-80 font-weight-500"
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/list_size')) + ": ")]), _vm._v(" "), _vm._l((_vm.Config.pageSizes), function(size) {
    return _c('span', {
      key: 'page-size-' + size,
      staticClass: "font-size-80",
      class: {
        'w5-link': size !== _vm.listData.pageSize, 'font-weight-500': size === _vm.listData.pageSize
      },
      on: {
        "click": function($event) {
          return _vm.setPageSize(size)
        }
      }
    }, [_vm._v("\n\t\t\t\t\t\t " + _vm._s(size) + " \n\t\t\t\t\t")])
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.listData && _vm.listData.rows && _vm.listData.rows.length && _vm.paginationPages.length > 0) ? _c('div', [(_vm.crud === 'vds') ? _c('paginator', {
    attrs: {
      "baseUrl": '/vds/' + _vm.action,
      "pages": _vm.paginationPages,
      "curPage": _vm.page,
      "lastPage": _vm.lastPage
    }
  }) : _c('paginator', {
    attrs: {
      "baseUrl": '/' + _vm.crud + '/' + _vm.action + (_vm.crud === 'ticket' && _vm.action === 'department' ? '/' + _vm.ticketDepartmentId : ''),
      "pages": _vm.paginationPages,
      "curPage": _vm.page,
      "lastPage": _vm.lastPage,
      "queryString": _vm.getAllQueryParams()
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.listData && _vm.linkHint && _vm.linkHint.position === 'bottom') ? _c('div', {
    staticClass: "w5-info-link margin-top-20"
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "link"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.linkHint.link,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.linkHint.title)))]), _vm._v(" "), (_vm.linkHint.afterText) ? _c('span', {
    staticClass: "font-weight-500"
  }, [_vm._v(" " + _vm._s(_vm._f("ftc")(_vm.linkHint.afterText)))]) : _vm._e()], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showDeleteModal),
      expression: "showDeleteModal"
    }],
    staticClass: "modal-mask",
    on: {
      "click": _vm.hideDeleteModal
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "font-weight-500"
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.deleteModalTitle ? _vm.deleteModalTitle : '')))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.hideDeleteModal
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('p', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc(_vm.deleteModalText)),
      expression: "localeFtc(deleteModalText)"
    }],
    staticClass: "padding-0-5"
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    class: {
      'flbx': _vm.reserveIpLocalData >= 1, 'r': _vm.reserveIpLocalData && typeof _vm.reserveIpLocalData === 'object'
    }
  }, [(_vm.reserveIpLocalData && typeof _vm.reserveIpLocalData === 'object') ? _c('div', {
    staticClass: "tab-pane-command-wrapper",
    staticStyle: {
      "margin": "0 0 15px",
      "padding": "5px 10px 10px 10px",
      "text-align": "initial"
    }
  }, [_c('div', {
    staticClass: "control-wrapper"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reserveIpValue),
      expression: "reserveIpValue"
    }],
    staticClass: "w5-checkbox-field",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.reserveIpValue) ? _vm._i(_vm.reserveIpValue, null) > -1 : (_vm.reserveIpValue)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.reserveIpValue,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.reserveIpValue = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.reserveIpValue = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.reserveIpValue = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    class: {
      'disable': _vm.reserveIpProcessing || (_vm.deleteModalTimer && _vm.deleteModalTimer > 0)
    },
    staticStyle: {
      "display": "inline-block",
      "height": "3em",
      "line-height": "3em"
    },
    on: {
      "click": _vm.reserveIpStart
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("ftc")('main/save ippool/ippool')) + "\n\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc('service/reserve_ip_hint').replace('{cost}.', '{cost}').replace('{cost}', _vm.reserveIpCost)),
      expression: "localeFtc('service/reserve_ip_hint').replace('{cost}.', '{cost}').replace('{cost}', reserveIpCost)"
    }],
    staticClass: "warning-message",
    staticStyle: {
      "margin-bottom": "0",
      "font-size": "90%"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.reserveIpLocalData === 1) ? _c('div', [_c('img', {
    staticStyle: {
      "margin-left": "6px"
    },
    attrs: {
      "src": require("../../assets/img/loading-hor16.gif")
    }
  })]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "btn btn-submit btn-submit-danger pull-right",
    attrs: {
      "disabled": _vm.deleteModalTimer && _vm.deleteModalTimer > 0 ? 'disabled' : false
    },
    on: {
      "click": _vm.deleteModalCallback
    }
  }, [_vm._v(_vm._s(_vm.modalDeleteButtonTitle))])])])])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showBlockModal),
      expression: "showBlockModal"
    }],
    staticClass: "modal-mask",
    on: {
      "click": _vm.hideBlockModal
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "font-weight-500"
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.blockModalTitle ? _vm.blockModalTitle : '')))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.hideBlockModal
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    staticStyle: {
      "padding": "10px 15px",
      "text-align": "left"
    }
  }, [_c('p', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc(_vm.blockModalText)),
      expression: "localeFtc(blockModalText)"
    }],
    staticStyle: {
      "margin": "10px 0"
    }
  }), _vm._v(" "), _c('form', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.blockModalNoteRequired !== false),
      expression: "blockModalNoteRequired !== false"
    }],
    staticClass: "w5-from"
  }, [_c('fieldset', [_c('div', {
    staticClass: "w5-form-row"
  }, [_c('Field', {
    ref: "blockModalSelectNote",
    attrs: {
      "isVisibleRow": true,
      "crud": _vm.crud,
      "action": "list",
      "name": "blockModalSelectNote",
      "listBlockToOut": 1,
      "fieldInModal": true,
      "Field": {
        _field_name: 'blockModalSelectNote',
        type: 'list',
        title: 'notes/choice_note',
        '_visible': true,
        '_is_modal': true,
        url: '/text/list?search=template&category=notes&q='
      },
      "removeRightPadding": true
    },
    on: {
      "valueChanged": _vm.blockModalValueChanged
    },
    model: {
      value: (_vm.blockModalSelectNoteValue),
      callback: function($$v) {
        _vm.blockModalSelectNoteValue = $$v
      },
      expression: "blockModalSelectNoteValue"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "w5-form-row"
  }, [_c('Field', {
    ref: "blockModalTextNote",
    attrs: {
      "isVisibleRow": true,
      "crud": _vm.crud,
      "action": "list",
      "name": "blockModalTextNote",
      "Field": _vm.blockModalTextField,
      "removeRightPadding": true,
      "fieldInModal": true
    },
    on: {
      "focus": _vm.blockModalTextFieldFocus
    },
    model: {
      value: (_vm.blockModalTextNoteValue),
      callback: function($$v) {
        _vm.blockModalTextNoteValue = $$v
      },
      expression: "blockModalTextNoteValue"
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('span', {
    staticClass: "btn btn-submit btn-submit-danger pull-right",
    on: {
      "click": _vm.blockRowsInModalDialog
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.blockModalButtonTitle)))])])])])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showRegisterModal),
      expression: "showRegisterModal"
    }],
    staticClass: "modal-mask",
    on: {
      "click": _vm.hideRegisterModal
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container",
    class: {
      'wide': _vm.registerModalWhat === 'ip_off'
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "font-weight-500"
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.registerModalTitle ? _vm.registerModalTitle : 'server/register')))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.hideRegisterModal
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    staticStyle: {
      "padding": "10px 15px",
      "text-align": "left"
    }
  }, [_c('p', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc(_vm.registerModalText)),
      expression: "localeFtc(registerModalText)"
    }],
    staticStyle: {
      "margin": "10px 0"
    }
  }), _vm._v(" "), (_vm.registerModalWhat === 'ip_off') ? [_c('radioListComponent', {
    attrs: {
      "placeholder": "",
      "title": 'main/status',
      "required": true,
      "items": _vm.ippoolBlockStatuses
    },
    model: {
      value: (_vm.ippoolBlockValue),
      callback: function($$v) {
        _vm.ippoolBlockValue = $$v
      },
      expression: "ippoolBlockValue"
    }
  })] : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('span', {
    staticClass: "btn btn-submit btn-submit-danger pull-right",
    on: {
      "click": _vm.registerRowsInModalDialog
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.registerModalButtonTitle)))])])])])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showRemoveFilterModal),
      expression: "showRemoveFilterModal"
    }],
    staticClass: "modal-mask",
    on: {
      "click": _vm.hideRemoveFilterModal
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "font-weight-500"
  }, [_vm._v(_vm._s(_vm._f("ftc")('service/remove_filter')))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.hideRemoveFilterModal
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    staticStyle: {
      "padding": "10px 15px",
      "text-align": "left"
    }
  }, [_c('radioListComponent', {
    attrs: {
      "placeholder": "",
      "title": 'main/status',
      "required": true,
      "items": [{
          id: 'no-spamming',
          name: 'service/remove_filter_spam'
        },
        {
          id: 'block-services',
          name: 'service/remove_filter_service'
        },
        {
          id: 'no-dns',
          name: 'menu/dns'
        } ]
    },
    model: {
      value: (_vm.removeFilterValue),
      callback: function($$v) {
        _vm.removeFilterValue = $$v
      },
      expression: "removeFilterValue"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('span', {
    staticClass: "btn btn-submit btn-submit-danger pull-right",
    on: {
      "click": _vm.removeFilterProcessStart
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/detach')))])])])])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showCopyToDcModal),
      expression: "showCopyToDcModal"
    }],
    staticClass: "modal-mask",
    on: {
      "click": _vm.hideCopyToDcModal
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "font-weight-500"
  }, [_vm._v(_vm._s(_vm._f("ftc")('backup/copy')))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.hideCopyToDcModal
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('transition', {
    key: "transitionError",
    attrs: {
      "name": "fadeControl"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.copyToDcErrorMessage !== ''),
      expression: "copyToDcErrorMessage !== ''"
    }],
    staticClass: "alert alert-danger",
    staticStyle: {
      "margin": "5px 0 10px 0"
    },
    attrs: {
      "role": "alert"
    }
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "title": _vm._f("ftc")('main/close')
    },
    on: {
      "click": function($event) {
        _vm.copyToDcErrorMessage = ''
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc(_vm.copyToDcErrorMessage)),
      expression: "localeFtc(copyToDcErrorMessage)"
    }],
    staticStyle: {
      "padding": "0",
      "margin": "0"
    }
  })])]), _vm._v(" "), (_vm.copyToDcFields && _vm.copyToDcFields.fields) ? _vm._l((_vm.copyToDcFields.fields), function(row, index) {
    return _c('div', {
      key: 'copy_to_dc_field_' + index,
      class: {
        'w5-form-row': _vm.isVisibleField(row)
      }
    }, [(row) ? _vm._l((row), function(field) {
      return _c('Field', {
        key: 'field_' + field._field_name,
        attrs: {
          "isVisibleRow": _vm.isVisibleField(row),
          "crud": "backups",
          "action": "copy",
          "Field": field,
          "listBlockToOut": field.type === 'list' ? 1 : false,
          "removeRightPadding": true,
          "fieldInModal": true
        },
        on: {
          "valueChanged": function($event) {
            return _vm.onChangedField(field)
          },
          "blur": function($event) {
            return _vm.onBlurField(field)
          },
          "focus": function($event) {
            return _vm.onFocusField(field)
          },
          "enterKeyDown": function($event) {
            return _vm.onEnterKeyDownForm('copyToDcProcessStart')
          }
        },
        model: {
          value: (field.value),
          callback: function($$v) {
            _vm.$set(field, "value", $$v)
          },
          expression: "field.value"
        }
      })
    }) : _vm._e()], 2)
  }) : _vm._e(), _vm._v(" "), (_vm.copyToDcCostInfo) ? _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.copyToDcCostInfo)
    }
  }) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('span', {
    staticClass: "btn btn-submit pull-right",
    on: {
      "click": _vm.copyToDcProcessStart
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/copy')))])])])])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showVdsCloneModal),
      expression: "showVdsCloneModal"
    }],
    staticClass: "modal-mask",
    on: {
      "click": _vm.hideVdsCloneModal
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "font-weight-500"
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/clone')))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.hideVdsCloneModal
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "alert alert-warning margin-0"
  }, [_c('p', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc('main/vds_clone_note')),
      expression: "localeFtc('main/vds_clone_note')"
    }],
    staticClass: "padding-0-5"
  })]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-warning margin-top-10"
  }, [_c('p', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc('main/vds_clone_warning')),
      expression: "localeFtc('main/vds_clone_warning')"
    }],
    staticClass: "padding-0-5"
  })]), _vm._v(" "), _c('div', {
    staticClass: "w5-form-row"
  }, [_c('Field', {
    ref: "vdsCloneModalFieldBoolean",
    attrs: {
      "isVisibleRow": true,
      "crud": _vm.crud,
      "action": "list",
      "name": "vdsCloneModalFieldBoolean",
      "Field": _vm.vdsCloneModalFieldBoolean,
      "removeRightPadding": true,
      "fieldInModal": true
    },
    model: {
      value: (_vm.vdsCloneModalFieldBooleanValue),
      callback: function($$v) {
        _vm.vdsCloneModalFieldBooleanValue = $$v
      },
      expression: "vdsCloneModalFieldBooleanValue"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "w5-form-row"
  }, [_c('Field', {
    ref: "vdsCloneModalFieldList",
    attrs: {
      "isVisibleRow": true,
      "crud": _vm.crud,
      "action": "list",
      "name": "vdsCloneModalFieldList",
      "listBlockToOut": 1,
      "Field": _vm.vdsCloneModalFieldList,
      "removeRightPadding": true,
      "fieldInModal": true
    },
    on: {
      "focus": function($event) {
        _vm.vdsCloneModalFieldList._errMsg = ''
      }
    },
    model: {
      value: (_vm.vdsCloneModalFieldListValue),
      callback: function($$v) {
        _vm.vdsCloneModalFieldListValue = $$v
      },
      expression: "vdsCloneModalFieldListValue"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('span', {
    staticClass: "btn btn-submit pull-right",
    on: {
      "click": _vm.vdsCloneProcessStep2
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/begin')))])])])])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.vdsCloneShowProcessDataValue),
      expression: "vdsCloneShowProcessDataValue"
    }],
    staticClass: "modal-mask",
    on: {
      "click": _vm.hideVdsCloneProcessInfoModal
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "font-weight-500"
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/clone')))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.hideVdsCloneProcessInfoModal
    }
  }, [_vm._v("×")])]), _vm._v(" "), (_vm.vdsCloneShowProcessDataInfo && _vm.vdsCloneShowProcessDataInfo.id) ? _c('div', {
    staticClass: "modal-body"
  }, [(_vm.vdsCloneShowProcessDataInfo.error) ? [_c('div', {
    staticClass: "alert alert-warning margin-top-10"
  }, [_c('p', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc('main/vds_clone_process_warning')),
      expression: "localeFtc('main/vds_clone_process_warning')"
    }],
    staticClass: "padding-0-5"
  })]), _vm._v(" "), _c('div', {
    staticClass: "margin-bottom-15"
  }, [_c('strong', [_vm._v(_vm._s(_vm._f("ftc")('main/status')))]), _vm._v(": "), _c('span', [_vm._v(_vm._s(_vm._f("lower")(_vm._f("ftc")(_vm.vdsCloneShowProcessDataInfo.step))))])]), _vm._v(" "), _c('div', {
    staticClass: "margin-bottom-15"
  }, [_c('strong', [_vm._v(_vm._s(_vm._f("ftc")('service/status_error')))]), _vm._v(": "), _c('span', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc(_vm.vdsCloneShowProcessDataInfo.error)),
      expression: "localeFtc(vdsCloneShowProcessDataInfo.error)"
    }],
    staticStyle: {
      "color": "red"
    }
  })])] : (_vm.vdsCloneShowProcessDataInfo.finish) ? [_c('strong', [_vm._v(_vm._s(_vm._f("ftc")('operation/converted')))])] : [_c('div', {
    staticClass: "margin-bottom-15"
  }, [_c('strong', [_vm._v(_vm._s(_vm._f("ftc")('server/server')))]), _vm._v(": "), _c('span', [_vm._v(_vm._s(_vm.vdsCloneShowProcessDataInfo.params.nm))])]), _vm._v(" "), _c('div', {
    staticClass: "margin-bottom-15"
  }, [_c('strong', [_vm._v(_vm._s(_vm._f("ftc")('main/status')))]), _vm._v(": "), _c('span', [_vm._v(_vm._s(_vm._f("lower")(_vm._f("ftc")(_vm.vdsCloneShowProcessDataInfo.step))))])]), _vm._v(" "), _c('div', {
    staticClass: "margin-bottom-15"
  }, [_c('strong', [_vm._v(_vm._s(_vm._f("ftc")('main/state')))]), _vm._v(": "), _c('span', [_vm._v(_vm._s(_vm._f("lower")(_vm._f("ftc")(_vm.vdsCloneShowProcessDataInfo.status))))])])]], 2) : _vm._e(), _vm._v(" "), (_vm.vdsCloneShowProcessDataInfo && _vm.vdsCloneShowProcessDataInfo.id && _vm.vdsCloneShowProcessDataInfo.error) ? _c('div', {
    staticClass: "modal-footer"
  }, [_c('span', {
    staticClass: "btn btn-submit pull-right",
    on: {
      "click": function($event) {
        return _vm.deleteVdsCloneProcess(_vm.vdsCloneShowProcessDataInfo.id)
      }
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/vds_clone_process_terminate')))])]) : _vm._e()])])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showMigrateModal),
      expression: "showMigrateModal"
    }],
    staticClass: "modal-mask",
    on: {
      "click": _vm.hideMigrateModal
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container",
    staticStyle: {
      "width": "60%"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "font-weight-500"
  }, [_vm._v(_vm._s(_vm._f("ftc")('service/migrate')))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.hideMigrateModal
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('div', {
    staticClass: "w5-migrate-wrapper"
  }, [_c('div', {
    staticClass: "w5-migrate-vds-list scrollable"
  }, _vm._l((_vm.migrateRows), function(vds, indx) {
    return _c('div', {
      key: 'migrate-row-' + indx,
      staticClass: "w5-migrate-vds-list-item scrollable",
      class: {
        'w5-migrate-vds-list-item-selected': vds['migrate_active'] === true
      },
      style: (_vm.migrateRows.length <= 1 ? 'padding: 14px 8px;' : 'padding: 4px 8px;')
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t" + _vm._s(vds[_vm.listConfig['buttons']['migrate']]) + "\n\t\t\t\t\t\t\t\t\t")])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "w5-migrate-arrow"
  }, [_c('font-awesome-icon', {
    staticClass: "hidden-xs",
    attrs: {
      "icon": "arrow-right"
    }
  }), _vm._v(" "), _c('font-awesome-icon', {
    staticClass: "visible-xs",
    attrs: {
      "icon": "arrow-down"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "w5-migrate-server-list"
  }, [_c('form', {
    staticClass: "w5-from"
  }, [_c('fieldset', [_c('div', {
    staticClass: "w5-form-row"
  }, [_c('Field', {
    ref: "migrateModalSelectServer",
    attrs: {
      "isVisibleRow": true,
      "crud": _vm.crud,
      "action": "list",
      "name": "migrateModalSelectServer",
      "listBlockToOut": 1,
      "fieldInModal": true,
      "Field": _vm.migrateModalServerField,
      "removeRightPadding": true
    },
    on: {
      "valueChanged": _vm.migrateModalValueChanged
    },
    model: {
      value: (_vm.migrateModalSelectServerValue),
      callback: function($$v) {
        _vm.migrateModalSelectServerValue = $$v
      },
      expression: "migrateModalSelectServerValue"
    }
  })], 1)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('span', {
    staticClass: "btn btn-submit btn-submit-danger pull-right",
    attrs: {
      "disabled": _vm.migrateModalButtonDisabled ? 'disabled' : false
    },
    on: {
      "click": _vm.migrateInModalDialog
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('service/migrate')))])])])])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showServiceMoveModal),
      expression: "showServiceMoveModal"
    }],
    staticClass: "modal-mask",
    on: {
      "click": _vm.hideServiceMoveModal
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container",
    staticStyle: {
      "width": "60%"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "font-weight-500"
  }, [_vm._v(_vm._s(_vm._f("ftc")('service/move')))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.hideServiceMoveModal
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('div', {
    staticClass: "w5-migrate-wrapper"
  }, [_c('div', {
    staticClass: "w5-migrate-vds-list scrollable"
  }, _vm._l((_vm.serviceMoveRows), function(service, indx) {
    return _c('div', {
      key: 'service-move-row-' + indx,
      staticClass: "w5-migrate-vds-list-item scrollable",
      class: {
        'w5-migrate-vds-list-item-selected': service['move_active'] === true
      },
      style: (_vm.serviceMoveRows.length <= 1 ? 'padding: 14px 8px;' : 'padding: 4px 8px;')
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t" + _vm._s(service[_vm.listConfig['buttons']['serviceMove']]) + "\n\t\t\t\t\t\t\t\t\t")])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "w5-migrate-arrow"
  }, [_c('font-awesome-icon', {
    staticClass: "hidden-xs",
    attrs: {
      "icon": "arrow-right"
    }
  }), _vm._v(" "), _c('font-awesome-icon', {
    staticClass: "visible-xs",
    attrs: {
      "icon": "arrow-down"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "w5-migrate-server-list"
  }, [_c('form', {
    staticClass: "w5-from"
  }, [_c('fieldset', [_c('div', {
    staticClass: "w5-form-row"
  }, [_c('Field', {
    ref: "serviceMoveModalSelectServer",
    attrs: {
      "isVisibleRow": true,
      "crud": _vm.crud,
      "action": "list",
      "name": "serviceMoveModalSelectServer",
      "Field": _vm.serviceMoveModalAccountField,
      "listBlockToOut": 1,
      "fieldInModal": true,
      "removeRightPadding": true
    },
    on: {
      "valueChanged": _vm.serviceMoveModalValueChanged
    },
    model: {
      value: (_vm.serviceMoveModalSelectAccountValue),
      callback: function($$v) {
        _vm.serviceMoveModalSelectAccountValue = $$v
      },
      expression: "serviceMoveModalSelectAccountValue"
    }
  })], 1)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('span', {
    staticClass: "btn btn-submit btn-submit-danger pull-right",
    attrs: {
      "disabled": _vm.serviceMoveModalButtonDisabled ? 'disabled' : false
    },
    on: {
      "click": _vm.serviceMoveInModalDialog
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.serviceMoveModalButtonTitle)))])])])])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showServiceBulkDelModal),
      expression: "showServiceBulkDelModal"
    }],
    staticClass: "modal-mask",
    on: {
      "click": _vm.hideServiceBulkDelModal
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "font-weight-500"
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/deleting')))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.hideServiceBulkDelModal
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm._f("ftc")('main/delete_selected_records')) + "?\n\t\t\t\t\t\t\t"), _c('br'), _vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm._f("ftc")('main/delete_selected_records_note')) + "\n\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('span', {
    staticClass: "btn btn-submit btn-submit-danger pull-right",
    attrs: {
      "disabled": _vm.serviceBulkDelModalButtonDisabled ? 'disabled' : false
    },
    on: {
      "click": _vm.serviceBulkDelInModalDialog
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.serviceBulkDelModalButtonTitle)))])])])])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showTicketMoveModal),
      expression: "showTicketMoveModal"
    }],
    staticClass: "modal-mask",
    on: {
      "click": _vm.hideTicketMoveModal
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container",
    staticStyle: {
      "width": "60%"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "font-weight-500"
  }, [_vm._v(_vm._s(_vm._f("ftc")('ticketrule/action_move')))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.hideTicketMoveModal
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('div', {
    staticClass: "w5-ticket-move-wrapper"
  }, [_c('div', {
    staticClass: "w5-ticket-move-tickets-list"
  }, _vm._l((_vm.ticketRows), function(ticket, indx) {
    return _c('div', {
      key: 'ticket-move-row-' + indx,
      staticClass: "w5-ticket-move-tickets-list-item",
      class: {
        'w5-ticket-move-tickets-list-item-selected': ticket['ticket_move_active'] === true
      },
      style: (_vm.ticketRows.length <= 1 ? 'padding: 14px 8px;' : 'padding: 4px 8px;')
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t" + _vm._s(ticket['ticket_subject']) + "\n\t\t\t\t\t\t\t\t\t")])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "w5-ticket-move-arrow"
  }, [_c('font-awesome-icon', {
    staticClass: "hidden-xs",
    attrs: {
      "icon": "arrow-right"
    }
  }), _vm._v(" "), _c('font-awesome-icon', {
    staticClass: "visible-xs",
    attrs: {
      "icon": "arrow-down"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "w5-ticket-move-departments-list"
  }, [_c('form', {
    staticClass: "w5-from"
  }, [_c('fieldset', [_c('div', {
    staticClass: "w5-form-row"
  }, [_c('Field', {
    ref: "ticketMoveModalSelectDepartment",
    attrs: {
      "isVisibleRow": true,
      "crud": _vm.crud,
      "action": "list",
      "name": "ticketMoveModalSelectDepartment",
      "listBlockToOut": 1,
      "fieldInModal": true,
      "Field": _vm.ticketMoveModalDepartmentField,
      "removeRightPadding": true
    },
    on: {
      "valueChanged": _vm.ticketMoveModalValueChanged
    },
    model: {
      value: (_vm.ticketMoveModalSelectDepartmentValue),
      callback: function($$v) {
        _vm.ticketMoveModalSelectDepartmentValue = $$v
      },
      expression: "ticketMoveModalSelectDepartmentValue"
    }
  })], 1)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('span', {
    staticClass: "btn btn-submit btn-submit-danger pull-right",
    attrs: {
      "disabled": _vm.ticketMoveModalButtonDisabled ? 'disabled' : false
    },
    on: {
      "click": _vm.ticketMoveInModalDialog
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('ticketrule/action_move')))])])])])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showTicketBlockModal),
      expression: "showTicketBlockModal"
    }],
    staticClass: "modal-mask",
    on: {
      "click": _vm.hideTicketBlockModal
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container blacklist",
    staticStyle: {
      "width": "60%"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "font-weight-500"
  }, [_vm._v(_vm._s(_vm._f("ftc")('ticketrule/blacklist')))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.hideTicketBlockModal
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.ticketBlockModalBody) + "\n\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('span', {
    staticClass: "btn btn-submit btn-submit-danger pull-right",
    attrs: {
      "disabled": _vm.ticketBlockModalTimer && _vm.ticketBlockModalTimer > 0 ? 'disabled' : false
    },
    on: {
      "click": _vm.ticketBlockInModalDialog
    }
  }, [_vm._v(_vm._s(_vm.ticketBlockModalButtonTitle))])])])])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showISOModal),
      expression: "showISOModal"
    }],
    staticClass: "modal-mask",
    on: {
      "click": _vm.hideISOModal
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "font-weight-500"
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.isoModalTitle)))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.hideISOModal
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('p', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc(_vm.isoModalText)),
      expression: "localeFtc(isoModalText)"
    }],
    staticClass: "padding-0-5"
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('span', {
    staticClass: "btn btn-submit btn-submit-danger pull-right",
    attrs: {
      "disabled": _vm.blockModalTimer && _vm.blockModalTimer > 0 ? 'disabled' : false
    },
    on: {
      "click": _vm.detachIsoBegin
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.isoBlockModalButtonTitle)))])])])])])]), _vm._v(" "), (_vm.crud === 'backups') ? _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showDownloadBackupModal),
      expression: "showDownloadBackupModal"
    }],
    staticClass: "modal-mask",
    on: {
      "click": _vm.hideDownloadBackupModal
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "font-weight-500"
  }, [_vm._v(_vm._s(_vm._f("ftc")('backup/download_title')))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.hideDownloadBackupModal
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('p', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc('backup/download_info')),
      expression: "localeFtc('backup/download_info')"
    }],
    staticClass: "padding-0-5"
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('span', {
    staticClass: "btn btn-submit pull-right",
    on: {
      "click": _vm.downloadBackupProcessStart
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/download')))])])])])])]) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showPaymentModal),
      expression: "showPaymentModal"
    }],
    staticClass: "modal-mask",
    on: {
      "click": _vm.hidePaymentModal
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "font-weight-500"
  }, [_vm._v(_vm._s(_vm._f("ftc")('operation/convert_title')))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.hidePaymentModal
    }
  }, [_vm._v("×")])]), _vm._v(" "), (_vm.paymentFields && _vm.paymentFields.fields) ? _c('div', {
    staticClass: "modal-body"
  }, _vm._l((_vm.paymentFields.fields), function(row, index) {
    return _c('div', {
      key: 'payment_field_' + index,
      class: {
        'w5-form-row': _vm.isVisiblePaymentField(row)
      }
    }, [(row) ? _vm._l((row), function(field) {
      return _c('Field', {
        key: 'field_' + field._field_name,
        attrs: {
          "isVisibleRow": _vm.isVisiblePaymentField(row),
          "crud": "operation",
          "action": "convert",
          "Field": field,
          "listBlockToOut": field.type === 'list' ? 1 : false,
          "removeRightPadding": true,
          "fieldInModal": true
        },
        on: {
          "valueChanged": function($event) {
            return _vm.fieldChangedPayment(field)
          },
          "input": function($event) {
            return _vm.fieldPaymentInput(field)
          },
          "blur": function($event) {
            return _vm.onBlurPayment(field)
          },
          "focus": function($event) {
            return _vm.onFocusPayment(field)
          },
          "enterKeyDown": _vm.onEnterKeyDownPayment
        },
        model: {
          value: (field.value),
          callback: function($$v) {
            _vm.$set(field, "value", $$v)
          },
          expression: "field.value"
        }
      })
    }) : _vm._e()], 2)
  }), 0) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('span', {
    staticClass: "pull-left text-left"
  }, [_c('span', {
    style: (_vm.PaymentWarrning ? 'color: red' : false)
  }, [_vm._v(_vm._s(_vm._f("ftc")('payment/min')) + ": "), _c('strong', [_c('Money', {
    attrs: {
      "value": _vm.paymentMin
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc('main/ruble')),
      expression: "localeFtc('main/ruble')"
    }]
  })], 1)]), _vm._v(" "), (_vm.PaymentWarrningAdditional) ? [_c('br'), _vm._v(" "), _c('span', {
    staticClass: "payment-warrning-text"
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.PaymentWarrningAdditional)))])] : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("ftc")('payment/max')) + ": "), _c('strong', [_c('Money', {
    attrs: {
      "value": _vm.paymentMax
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc('main/ruble')),
      expression: "localeFtc('main/ruble')"
    }]
  })], 1)])], 2), _vm._v(" "), _c('span', {
    staticClass: "btn btn-submit pull-right",
    attrs: {
      "disabled": _vm.isPaymentModalButtonDisabled
    },
    on: {
      "click": _vm.paymentConvertBegin
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('operation/convert')))])])])])])]), _vm._v(" "), (_vm.crud == 'operation') ? _c('calculator', {
    attrs: {
      "visible": _vm.showCalcModal
    },
    on: {
      "onClose": _vm.hideCalcModal
    }
  }) : _vm._e(), _vm._v(" "), (_vm.crud == 'rack') ? _c('rackGraphic', {
    attrs: {
      "visible": _vm.showRackGraphicModal,
      "rack": _vm.rackGraphicModalData,
      "filters": _vm.listData && _vm.listData.filters && _vm.listData.filters.rack_type ? _vm.listData.filters : null
    },
    on: {
      "onClose": _vm.hideRackGraphicModal
    }
  }) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [(_vm.showBalancePopup) ? _c('div', {
    staticClass: "popup-mask",
    on: {
      "mousedown": function($event) {
        _vm.maskModalFlag = true
      },
      "mouseup": function () { return this$1.hideBalancePopup(false); }
    }
  }, [_c('div', {
    staticClass: "popup-wrapper"
  }, [_c('div', {
    staticClass: "popup-container",
    style: (_vm.balanceContainerStyle),
    on: {
      "mousedown": function($event) {
        $event.stopPropagation();
        _vm.maskModalFlag = false
      },
      "mouseup": function($event) {
        $event.stopPropagation();
        _vm.maskModalFlag = false
      }
    }
  }, [_c('Field', {
    ref: "clientBalance",
    attrs: {
      "isVisibleRow": true,
      "crud": _vm.crud,
      "action": "list",
      "name": "clientBalance",
      "needButtonSubmit": true,
      "Field": _vm.balanceField,
      "fieldInModal": true
    },
    on: {
      "enterKeyDown": _vm.onBalanceSubmit,
      "onSubmit": _vm.onBalanceSubmit,
      "focus": function($event) {
        _vm.balanceField._errMsg = ''
      }
    },
    model: {
      value: (_vm.balanceValue),
      callback: function($$v) {
        _vm.balanceValue = $$v
      },
      expression: "balanceValue"
    }
  })], 1)])]) : _vm._e()]), _vm._v(" "), (_vm.crud === 'ticket') ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showChoiceTicketLabelBlock === true),
      expression: "showChoiceTicketLabelBlock === true"
    }],
    ref: "ticketChoiceLabelBlock",
    staticClass: "widget-filter-ticket-label-choice",
    style: (_vm.ticketLabelBlockStyle)
  }, [_vm._l((_vm.ticketLabelItems), function(val, idx) {
    return [(String(val) !== '') ? _c('div', {
      key: 'label-change-block-' + idx,
      staticClass: "w5-list-ticket-label cursor-pointer",
      class: 'ticket-label-color-' + String(val).toLowerCase(),
      style: ('background-color: ' + String(val).toLowerCase()),
      on: {
        "click": function($event) {
          return _vm.onChangeTicketLabel(val)
        }
      }
    }) : _vm._e()]
  })], 2) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showMarkTicketsAsReadedDialog),
      expression: "showMarkTicketsAsReadedDialog"
    }],
    staticClass: "modal-mask",
    on: {
      "click": function($event) {
        _vm.showMarkTicketsAsReadedDialog = false
      }
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "font-weight-500"
  }, [_vm._v(_vm._s(_vm._f("ftc")('ticket/mark_all_as_readed')))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.showMarkTicketsAsReadedDialog = false
      }
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_vm._v(_vm._s(_vm._f("ftc")('ticket/mark_all_as_readed_warning')))]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('span', {
    staticClass: "btn btn-submit btn-submit-danger pull-right",
    on: {
      "click": _vm.markTicketsAsReadedStart
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/confirm')))])])])])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showConfirmModalDialog),
      expression: "showConfirmModalDialog"
    }],
    staticClass: "modal-mask",
    on: {
      "click": _vm.hideConfirmModalDialog
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "font-weight-500"
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.confirmModalDialogTitle ? _vm.confirmModalDialogTitle : '')))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.hideConfirmModalDialog
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('p', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc(_vm.confirmModalDialogText)),
      expression: "localeFtc(confirmModalDialogText)"
    }],
    staticClass: "padding-0-5"
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('span', {
    staticClass: "btn btn-submit pull-right",
    on: {
      "click": _vm.confirmModalDialogCallback
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/confirm')))])])])])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showMergeTicketsDialog),
      expression: "showMergeTicketsDialog"
    }],
    staticClass: "modal-mask",
    on: {
      "click": function($event) {
        _vm.showMergeTicketsDialog = false
      }
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "font-weight-500"
  }, [_vm._v(_vm._s(_vm._f("ftc")('ticket/merge')))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.showMergeTicketsDialog = false
      }
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "w5-form-row"
  }, [_c('Field', {
    ref: "mergeTicketsSelectTicket",
    attrs: {
      "isVisibleRow": true,
      "crud": _vm.crud,
      "action": "list",
      "name": "mergeTicketsSelectTicket",
      "listBlockToOut": 1,
      "Field": _vm.mergeTicketsField,
      "removeRightPadding": true,
      "fieldInModal": true
    },
    on: {
      "focus": function($event) {
        _vm.mergeTicketsField._errMsg = ''
      }
    },
    model: {
      value: (_vm.mergeTicketsField.value),
      callback: function($$v) {
        _vm.$set(_vm.mergeTicketsField, "value", $$v)
      },
      expression: "mergeTicketsField.value"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('span', {
    staticClass: "btn btn-submit pull-right",
    on: {
      "click": _vm.mergeTicketsStart
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/continue')))])])])])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showPaymentLinkDialog),
      expression: "showPaymentLinkDialog"
    }],
    staticClass: "modal-mask",
    on: {
      "click": _vm.hidePaymentLinkDialog
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container not-so-wide",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "font-weight-500"
  }, [_vm._v(_vm._s(_vm._f("ftc")('operation/payment_link')))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.hidePaymentLinkDialog
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "w5-form-row"
  }, [_c('p', {
    staticClass: "payment-link"
  }, [_vm._v(_vm._s(_vm._f("ftc")('operation/payment_link_description')))])]), _vm._v(" "), _c('div', {
    staticClass: "w5-form-row"
  }, [_c('a', {
    ref: "paymentLinkUrl",
    staticClass: "payment-link",
    attrs: {
      "href": _vm.paymentLinkUrl,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.paymentLinkUrl))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('span', {
    staticClass: "btn btn-submit pull-right",
    on: {
      "click": _vm.copyPaymentLink
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/copy_to_clipboard')))])])])])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showDocumentModalDialog),
      expression: "showDocumentModalDialog"
    }],
    staticClass: "modal-mask",
    on: {
      "click": _vm.hideDocumentModalDialog
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container for-document",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "font-weight-500"
  }, [_vm._v(_vm._s(_vm._f("ftc")('document/document')))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.hideDocumentModalDialog
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "document-wrapper"
  }, [_c('iframe', {
    attrs: {
      "width": "100%",
      "frameborder": "0",
      "id": "documentFrame",
      "name": "documentFrame",
      "seamless": ""
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\tВаш браузер не поддерживает показ документа\n\t\t\t\t\t\t\t\t")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [(_vm.isPrintReady) ? _c('span', {
    staticClass: "btn btn-submit pull-left",
    on: {
      "click": _vm.documentPrint
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/print')))]) : _vm._e(), _vm._v(" "), (_vm.documentModalDialogLinkXml) ? _c('a', {
    staticClass: "btn btn-submit pull-right",
    attrs: {
      "href": _vm.documentModalDialogLinkXml,
      "download": "download"
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/download XML')))]) : _vm._e(), _vm._v(" "), (_vm.documentModalDialogLinkPdf) ? _c('a', {
    staticClass: "btn btn-submit pull-right",
    attrs: {
      "href": _vm.documentModalDialogLinkPdf,
      "download": "download"
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/download PDF')))]) : _vm._e()])])])])]), _vm._v(" "), (_vm.crud === 'backups') ? _c('backupDialog', {
    attrs: {
      "visible": _vm.showBackupDialog,
      "type": _vm.backupDialogType,
      "user-type": _vm.$store.state.user_type,
      "account-id": _vm.backupDialogAccount,
      "backup-id": _vm.backupDialogId,
      "backup-name": _vm.backupDialogName
    },
    on: {
      "onClose": _vm.hideBackupDialog,
      "onAction": _vm.backupDialogStartProcess
    }
  }) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showRenameBackupDialog),
      expression: "showRenameBackupDialog"
    }],
    staticClass: "modal-mask",
    on: {
      "click": _vm.hideRenameBackupDialog
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "font-weight-500"
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/name')))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.hideRenameBackupDialog
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    staticStyle: {
      "padding": "10px 15px",
      "text-align": "left"
    }
  }, [_c('form', {
    staticClass: "w5-from"
  }, [_c('fieldset', [_c('div', {
    staticClass: "w5-form-row"
  }, [_c('Field', {
    attrs: {
      "isVisibleRow": true,
      "crud": _vm.crud,
      "action": "list",
      "Field": _vm.renameBackupField,
      "removeRightPadding": true,
      "fieldInModal": true
    },
    on: {
      "enterKeyDown": _vm.renameBackupKeyDown,
      "focus": function($event) {
        _vm.renameBackupField._errMsg = ''
      }
    },
    model: {
      value: (_vm.renameBackupValue),
      callback: function($$v) {
        _vm.renameBackupValue = $$v
      },
      expression: "renameBackupValue"
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('span', {
    staticClass: "btn btn-submit btn-submit-danger pull-right",
    on: {
      "click": _vm.renameBackupStart
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('service/rename_action')))])])])])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showRestoreBackupOuterDiskDialog),
      expression: "showRestoreBackupOuterDiskDialog"
    }],
    staticClass: "modal-mask",
    on: {
      "click": _vm.hideRestoreBackupOuterDiskDialog
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "font-weight-500"
  }, [_vm._v(_vm._s(_vm._f("ftc")('service/restore')))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.hideRestoreBackupOuterDiskDialog
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    staticStyle: {
      "padding": "10px 15px",
      "text-align": "left"
    }
  }, [_c('form', {
    staticClass: "w5-from"
  }, [_c('fieldset', [_c('div', {
    staticClass: "w5-form-row"
  }, [_c('Field', {
    attrs: {
      "isVisibleRow": true,
      "crud": _vm.crud,
      "action": "list",
      "Field": _vm.restoreBackupOuterDiskField,
      "removeRightPadding": true,
      "fieldInModal": true,
      "listBlockToOut": 1
    },
    on: {
      "focus": function($event) {
        _vm.restoreBackupOuterDiskField._errMsg = ''
      },
      "input": _vm.restoreBackupOuterDiskFieldChanged
    },
    model: {
      value: (_vm.restoreBackupOuterDiskValue),
      callback: function($$v) {
        _vm.restoreBackupOuterDiskValue = $$v
      },
      expression: "restoreBackupOuterDiskValue"
    }
  })], 1), _vm._v(" "), (_vm.restoreBackupOuterDiskWarning) ? _c('div', {
    staticClass: "w5-form-row"
  }, [_c('p', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc(_vm.restoreBackupOuterDiskWarning)),
      expression: "localeFtc(restoreBackupOuterDiskWarning)"
    }]
  })]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('span', {
    staticClass: "btn btn-submit btn-submit-danger pull-right",
    on: {
      "click": _vm.restoreBackupOuterDiskStart
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/restore')))])])])])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showBackupScheduleModal),
      expression: "showBackupScheduleModal"
    }],
    staticClass: "modal-mask",
    on: {
      "click": _vm.hideBackupScheduleModal
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container modal-form",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "font-weight-500"
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.backupScheduleMode === 'create' ? 'schedule/create_title' : 'schedule/update_title')))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.hideBackupScheduleModal
    }
  }, [_vm._v("×")])]), _vm._v(" "), (_vm.backupScheduleForm && _vm.backupScheduleForm.fields) ? _c('div', {
    staticClass: "modal-body"
  }, [_c('form', {
    staticClass: "w5-from"
  }, [_c('fieldset', {
    attrs: {
      "disabled": _vm.form_Loading
    }
  }, _vm._l((_vm.backupScheduleForm.fields), function(row, index) {
    return _c('div', {
      key: index,
      class: {
        'w5-form-row': _vm.isVisibleScheduleField(row)
      }
    }, [(row) ? _vm._l((row), function(field) {
      return _c('Field', {
        key: field._field_name,
        attrs: {
          "isVisibleRow": _vm.isVisibleScheduleField(row),
          "fieldInModal": true,
          "action": _vm.backupScheduleMode,
          "Field": field,
          "listBlockToOut": 1,
          "crud": "backupschedule"
        },
        on: {
          "valueChanged": function($event) {
            return _vm.fieldScheduleChanged(field)
          }
        },
        model: {
          value: (field.value),
          callback: function($$v) {
            _vm.$set(field, "value", $$v)
          },
          expression: "field.value"
        }
      })
    }) : _vm._e()], 2)
  }), 0)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('span', {
    staticClass: "btn btn-submit pull-right",
    attrs: {
      "disabled": _vm.createScheduleEmpty
    },
    on: {
      "click": _vm.createBackupScheduleBegin
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.backupScheduleMode === 'create' ? 'schedule/create_title' : 'schedule/update_title')))])])])])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showConnectOuterDiskDialog),
      expression: "showConnectOuterDiskDialog"
    }],
    staticClass: "modal-mask",
    on: {
      "click": _vm.hideConnectOuterDiskDialog
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container wide",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "font-weight-500"
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.connectOuterDiskDialogMode == 'disk' ? 'main/attach main/disk' : 'service/iso_insert')))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.hideConnectOuterDiskDialog
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    staticStyle: {
      "padding": "10px 15px",
      "text-align": "left"
    }
  }, [_c('form', {
    staticClass: "w5-from"
  }, [_c('fieldset', [_c('div', {
    staticClass: "w5-form-row"
  }, [_c('Field', {
    attrs: {
      "isVisibleRow": true,
      "crud": _vm.crud,
      "action": "list",
      "Field": _vm.connectOuterDiskField,
      "removeRightPadding": true,
      "fieldInModal": true,
      "listBlockToOut": 1
    },
    on: {
      "focus": function($event) {
        _vm.connectOuterDiskField._errMsg = ''
      }
    },
    model: {
      value: (_vm.connectOuterDiskValue),
      callback: function($$v) {
        _vm.connectOuterDiskValue = $$v
      },
      expression: "connectOuterDiskValue"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "margin-top-15 margin-bottom-10 margin-right-10"
  }, [_c('p', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc('service/iso_operation_warning')),
      expression: "localeFtc('service/iso_operation_warning')"
    }]
  })])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('span', {
    staticClass: "btn btn-submit pull-right",
    on: {
      "click": function () { return _vm.connectOuterDiskDialogMode == 'disk' ? _vm.connectOuterDiskDialogStartProcess() : _vm.connectISOOperDialogStartProcess(); }
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/attach')))])])])])])]), _vm._v(" "), (_vm.crud === 'logs' && _vm.$store.state.user_type === 'admin') ? _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showViewModal),
      expression: "showViewModal"
    }],
    staticClass: "modal-mask",
    on: {
      "click": _vm.hideViewModal
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "font-weight-500"
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.viewData && _vm.viewData.title ? _vm.viewData.title : 'ippool/ippool')))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.hideViewModal
    }
  }, [_vm._v("×")])]), _vm._v(" "), (_vm.viewKeys && _vm.viewKeys.length) ? _c('div', {
    staticClass: "modal-body"
  }, _vm._l((_vm.viewKeys), function(row) {
    return _c('div', {
      key: row,
      staticClass: "w5-form-row"
    }, _vm._l((_vm.viewSortDATA[row]), function(field, idx) {
      return _c('viewComponent', {
        key: row + '_' + idx,
        attrs: {
          "data": _vm.viewData,
          "rowCount": _vm.viewSortDATA[row].length,
          "y": row,
          "x": idx,
          "field": field,
          "crud": "logsIpBlackList",
          "realCrudName": "logsIpBlackList",
          "firstElement": _vm.viewSortDATA && _vm.viewSortDATA['1'] && _vm.viewSortDATA['1'][0] ? _vm.viewSortDATA['1'][0] : null
        }
      })
    }), 1)
  }), 0) : _vm._e(), _vm._v(" "), (_vm.viewData && _vm.viewData.__ip && _vm.viewData.__ip.can_flush === true) ? _c('div', {
    staticClass: "modal-footer"
  }, [_c('span', {
    staticClass: "btn btn-submit btn-submit-danger pull-right",
    on: {
      "click": _vm.viewButtonProcedure
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/delete')))])]) : _c('div', {
    staticClass: "padding-top-10"
  })])])])]) : _vm._e(), _vm._v(" "), _c('transition', {
    key: "transitionSuccess",
    attrs: {
      "name": "fallingBlock"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.localSuccessMessage !== ''),
      expression: "localSuccessMessage !== ''"
    }],
    staticClass: "alert alert-success font-size-90 falling-block",
    staticStyle: {
      "margin-right": "10px",
      "word-break": "break-word"
    },
    attrs: {
      "role": "alert"
    }
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "title": _vm._f("ftc")('main/close')
    },
    on: {
      "click": function($event) {
        _vm.localSuccessMessage = ''
      }
    }
  }, [_vm._v("×")]), _vm._v("\n\t\t\t\t" + _vm._s(_vm._f("ftc")(_vm.localSuccessMessage)) + "\n\t\t\t")])]), _vm._v(" "), _c('span', {
    staticClass: "ticket-last-commentator",
    style: (_vm.ticketLastCommentatorStyle)
  }, [_c('span', [_vm._v(_vm._s(_vm._f("ftc")('ticket/last_message_from: ')))]), _c('strong', [_vm._v(_vm._s(_vm._f("ftc")(_vm.ticketLastCommentator)))])])] : _c('errorAlert', {
    attrs: {
      "message": _vm.form_ErrorMessage
    }
  })], 2) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-70168cd6"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/crud/List.vue
// module id = 549
// module chunks = 0